import { grey } from '@material-ui/core/colors';
import {
  OccupancyRate,
  ADR,
  Revenue,
  ColorbarData,
  Host,
  ProductIDOptionsType,
  PieChartData,
  BarGraphData,
} from 'src/interfaces/idashboard';

import AirbticsProImageUS from 'src/App/assets/airbtics_pro_us_cover.jpg';
import AirbticsProImageUK from 'src/App/assets/airbtics_pro_uk_cover.jpg';
import AirbticsProImageCA from 'src/App/assets/airbtics_pro_ca_cover.jpg';
import AirbticsProImageAU from 'src/App/assets/airbtics_pro_au_cover.jpg';

export const LIGHT_GREY = grey[200];
export const DARK_GREY = grey[600];
export const LIGHT_GREY_2 = grey[400];
export const MID_GREY = '#555';

export const BACKGROUND_COLOR = '#F3FAFB'; //'#f7f8fb'//'#EEFCFB'//

export const COLOR_PRIMARY_DARK = '#037A90';
export const COLOR_PRIMARY = '#3AAFA9'; //"#00C2BA"
export const COLOR_PRIMARY_LIGHT = '#65ccb8';
export const COLOR_FORM_BACKGROUND = '#85CACC';

export const COLOR_ACCENT_1 = '#FF2079'; //"#FE1C80"//"#FF8FCF"
export const COLOR_ACCENT_1_GRADIENT = [
  '#ffe0ed',
  '#ffb3d1',
  '#ff80b2',
  '#ff4d94',
  '#ff1a75',
  '#e6005c',
  '#b30047',
  '#800033',
  '#4d001f',
  '#1a000a',
];
export const COLOR_ACCENT_2 = '#FF5F01'; //"#FF5F01"//"#CE96FB"
export const COLOR_ACCENT_2_CONTRAST = '#64b5f6';
export const COLOR_ACCENT_2_GRADIENT = ['#0a62a9', '#e7f3fe'];
export const COLOR_E = '#551A8B'; //'SAMPLE' WATERMARK
export const COLOR_F = '#ffab00';
export const COLOR_F_CONSTRAST = '#ff8000';
export const COLOR_F_GRADIENT = [
  '#ffeabf',
  '#ffdc95',
  '#ffce6a',
  '#ffc040',
  '#ffb215',
  '#ea9d00',
  '#bf8000',
  '#956400',
  '#6a4700',
  '#402b00',
];
export const COLOR_G_GRADIENT = ['#e5fcff', '#b3f7ff', '#80f2ff', '#4dedff'];
export const COLOR_GREEN = '#00cc00';
export const COLOR_GREEN_ACCENT_1 = '#3AB659';
export const COLOR_RED = '#cc0000';
export const COLOR_RED_LIGHT = '#E32636';
export const COLOR_GREY = '#696969';
export const COLOR_ORANGE = '#FFA500';
export const COLOR_YELLOW = '#EDD94C';
export const COLOR_GOLD = 'FFC700';
export const COLOR_TOOLTIP_BACKGROUND = '#E6F2F2';
export const COLOR_BLACK = '#000';
export const COLOR_BLUE_BLACK_LIGHT = '#292B3D';
export const COLOR_WHITE = '#fff';
export const COLOR_WHITE_ACCENT = '#DAEDE7';
export const COLOR_GOLDEN_YELLOW = '#EDD94C';
export const COLOR_LIGHT_PURPLE = '#8E30FF';
export const COLOR_VERIFIED_TICK = '#42A5F5';

export const SUPPLY_DEMAND_GRAPH_YELLOW = '#E3AF64';
export const SUPPLY_DEMAND_GRAPH_BLUE = '#518FD4';

export const COLOR_AIRBNB_MARKERS = COLOR_ACCENT_1;
export const COLOR_VRBO_MARKER = '#6a6aff';
export const COLOR_BOOKING_COM_MARKER = '#1c39bb';
export const COLOR_TRIPADVISOR_MARKER = '#a9ff39';

export const OTA_MARKER_COLOR = '#FFBF99';

// export const COLOR_RANGE_AIRBNB_MARKERS = ['#10D4FF', '#FBEC07', '#FF2079', '#DA1D00'];
export const COLOR_RANGE_AIRBNB_MARKERS = ['#FF9F67', '#FF79AF', '#FF2079', '#DA1D00'];

export const MARKETPLACE_GREEN = '#3FFAC2';

export const POINTER_GREEN = '#4aa59a';

export const COLOR_PALETTE_1 = '#f15b82';

export const INDIVIDUAL_LISTING_TOOLTIP_BUTTON_COLOR = '#315bb5';
export const INDIVIDUAL_LISTING_TOOLTIP_BUTTON_HOVER_COLOR = '#3777ff';

// Color shade for inactive sectors of the pie
export const INACTIVE_COLORS = Array(10).fill(COLOR_PRIMARY);

export const COLORS_PROPERTY_SIZE = [
  '#f05a67',
  '#65CCB8',
  '#faaebe',
  '#ffd85a',
  '#b2cf65',
  '#21c5c7',
  COLOR_PALETTE_1,
];

export const COLORS_BOOKING_TYPE = ['#8E30FF', '#FF5E78', '#65CCB8'];
export const COLORS_BOOKING_LEAD_TIME = ['#1BD6EF', '#FF5E78', '#EDD94C'];
export const COLORS_TOP_3_MARKET_LEADERS = ['#EBEF1B', '#65CCB8', '#FF7723'];

export const INNERPIE_COLORS = [
  COLOR_ACCENT_1,
  COLOR_VRBO_MARKER,
  COLOR_BOOKING_COM_MARKER,
  COLOR_TRIPADVISOR_MARKER,
];

export const COMPETITOR_RATES_COLORS = [
  '#E74645',
  '#DBA507',
  '#1AC0C6',
  '#0D6986',
  '#9768D1',
  '#B64926',
  '#F5487F',
  '#E74645',
  '#679186',
  '#F9B4AB',
];
export const AVAILABLE_NIGHT_COLOR = SUPPLY_DEMAND_GRAPH_BLUE;
export const BOOKED_NIGHT_COLOR = SUPPLY_DEMAND_GRAPH_YELLOW;

export const HOMEPAGE_PINK = '#0E6BA8';
export const HOMEPAGE_DARK_BLUE = '#0E3B43';

export const PAYMENT_MODAL_GREEN = '#61BFBA';
export const PAYMENT_MODAL_GREEN_HOVER = '#1C879B';

export const gradient = [
  'rgba(0, 255, 255, 0)',
  'rgba(0, 255, 255, 1)',
  'rgba(0, 191, 255, 1)',
  'rgba(0, 127, 255, 1)',
  'rgba(0, 63, 255, 1)',
  'rgba(0, 0, 255, 1)',
  'rgba(0, 0, 223, 1)',
  'rgba(0, 0, 191, 1)',
  'rgba(0, 0, 159, 1)',
  'rgba(0, 0, 127, 1)',
  'rgba(63, 0, 91, 1)',
  'rgba(127, 0, 63, 1)',
  'rgba(191, 0, 31, 1)',
  'rgba(255, 0, 0, 1)',
];

export const activeListingAsPerCountryTier = {
  tier1: 1000000,
  tier2: 250000,
  tier3: 50000,
};

export const countryCodeToNumberOfListingsCountryPlan = {
  us: 1000000,
  fr: 1000000,
  ca: 500000,
  au: 500000,
  de: 500000,
  it: 500000,
  jp: 500000,
  gb: 500000,
  other: 250000,
};

export let gradientCss = 'linear-gradient(to right';
for (let i = 0; i < gradient.length; ++i) {
  gradientCss += ', ' + gradient[i];
}
gradientCss += ')';

export const mapStyles = [
  // {
  //   featureType: 'landscape',
  //   stylers: [
  //     {
  //       hue: '#FFBB00',
  //     },
  //     {
  //       saturation: 43.400000000000006,
  //     },
  //     {
  //       lightness: 37.599999999999994,
  //     },
  //     {
  //       gamma: 1,
  //     },
  //   ],
  // },
  {
    featureType: 'road.highway',
    stylers: [
      {
        hue: '#FFC200',
      },
      {
        saturation: -61.8,
      },
      {
        lightness: 45.599999999999994,
      },
      {
        gamma: 1,
      },
    ],
  },
  {
    featureType: 'road.arterial',
    stylers: [
      {
        hue: '#FF0300',
      },
      {
        saturation: -100,
      },
      {
        lightness: 51.19999999999999,
      },
      {
        gamma: 1,
      },
    ],
  },
  {
    featureType: 'road.local',
    stylers: [
      {
        hue: '#FF0300',
      },
      {
        saturation: -100,
      },
      {
        lightness: 52,
      },
      {
        gamma: 1,
      },
    ],
  },
  {
    featureType: 'water',
    stylers: [
      {
        hue: '#0078FF',
      },
      {
        saturation: -13.200000000000003,
      },
      {
        lightness: 2.4000000000000057,
      },
      {
        gamma: 1,
      },
    ],
  },
  {
    featureType: 'poi',
    stylers: [
      {
        hue: '#00FF6A',
      },
      {
        saturation: -1.0989010989011234,
      },
      {
        lightness: 11.200000000000017,
      },
      {
        gamma: 1,
      },
    ],
  },
];

export const mapOptions = {
  styles: mapStyles, // straight out of something like snazzymaps
};

export const sidebarWidth = 175;
export const sidebarClosedWidth = 64;
export const HEADER_HEIGHT = '80px';
export const FILTER_WIDTH = '500px';

export const RoutesMap = {
  Home: '/',
  Login: '/login',
  Register: '/register',
  Payment: '/payment',
  PaymentSuccess: '/subscribed',
  Calculator: '/airbnb-calculator',
  Discovery: '/markets',
  SampleDashboard: '/sample',
  TailoredRegion: '/tailored',
  VerifyEmail: '/verify-email',
  Data: '/airbnb-data',
  CompSet: '/compset',
  User: '/user',
  Error: '/error',
  Pricing: '/pricing',
  ResetPassword: '/reset-password',
  IBAS: '/admin/ibas',
  ActiveMarkets: '/admin/active-markets',
  CreateBigMarket: '/admin/big-markets/create',
  GetBigMarkets: '/admin/big-markets',
  MyAnalysis: '/my-analysis',
  AirbnbPro: '/airbtics-pro',
  Admin: '/admin',
  AI: '/ai',
  Partner: '/partner',
  ApiCallsTracker: '/api-calls-tracker',
};

export const ProductIDOptions: ProductIDOptionsType = {
  starter: {
    productID: {
      monthly: 'price_1Nd9SWBVoeq938b5dSwwgLpm',
      quarterly: 'price_1PLQJYBVoeq938b5aS22jXcO',
      yearly: 'price_1Nd9bVBVoeq938b5axhalhs7',
    },
    markets: 1,
    estimatorCredits: 20,
    discountPercentage: {
      monthly: 0,
      yearly: 40,
    },
  },
  standard: {
    productID: {
      monthly: 'price_1Nd9BkBVoeq938b5oBgDdI21',
      quarterly: 'price_1PLQjDBVoeq938b5Au6gqVlK',
      yearly: 'price_1Nd9D6BVoeq938b550lezw7Z',
    },
    markets: 5,
    estimatorCredits: 50,
    discountPercentage: {
      monthly: 0,
      yearly: 45,
    },
  },
  enterprise: {
    productID: {
      monthly: 'price_1PLRTaBVoeq938b5LOda4ob9',
      quarterly: 'price_1PLRwjBVoeq938b5C24IXEJC',
      yearly: 'price_1LcVz0BVoeq938b5iC0s6x2w',
    },
    markets: 30,
    estimatorCredits: 300,
    discountPercentage: {
      monthly: 0,
      yearly: 45,
    },
  },
  global: {
    productID: {
      monthly: 'price_1P8KKRBVoeq938b59mjDcMEW',
      yearly: 'price_1P6XDHBVoeq938b5htgKKodL',
    },
    markets: 1,
    estimatorCredits: 20,
    discountPercentage: {
      monthly: 0,
      yearly: 0,
    },
  },
  pro: {
    productID: {
      monthly: 'price_1PNvF6BVoeq938b5bdLIXOCu',
      yearly: 'price_1PNvUUBVoeq938b5EdlyQjQI',
    },
    markets: 1,
    estimatorCredits: 20,
    discountPercentage: {
      monthly: 0,
      yearly: 0,
    },
  },
  expert: {
    productID: {
      monthly: 'price_1PNuokBVoeq938b5oAZLxJeH',
      yearly: 'price_1PNuxhBVoeq938b57qNUXqoX',
    },
    markets: 1,
    estimatorCredits: 20,
    discountPercentage: {
      monthly: 0,
      yearly: 0,
    },
  },
};

export const CountryCodeWithCurrency = {
  US: 'USD',
  EC: 'USD',
  SV: 'USD',
  ZW: 'USD',
  VG: 'USD',
  TC: 'USD',
  TL: 'USD',
  BQ: 'USD',
  FM: 'USD',
  PW: 'USD',
  MH: 'USD',
  PA: 'USD',
  CA: 'CAD',
  UK: 'GBP',
  GS: 'GBP',
  AU: 'AUD',
  CX: 'AUD',
  NR: 'AUD',
  NF: 'AUD',
  HM: 'AUD',
  AT: 'EUR',
  BE: 'EUR',
  HR: 'EUR',
  CY: 'EUR',
  EE: 'EUR',
  FI: 'EUR',
  FR: 'EUR',
  DE: 'EUR',
  GR: 'EUR',
  IE: 'EUR',
  IT: 'EUR',
  LV: 'EUR',
  LT: 'EUR',
  LU: 'EUR',
  MT: 'EUR',
  NL: 'EUR',
  AN: 'EUR',
  PT: 'EUR',
  SK: 'EUR',
  SI: 'EUR',
  ES: 'EUR',
  AD: 'EUR',
  AL: 'EUR',
  AX: 'EUR',
  BA: 'EUR',
  BG: 'EUR',
  BY: 'EUR',
  CH: 'EUR',
  CZ: 'EUR',
  DK: 'EUR',
  FO: 'EUR',
  GB: 'GBP',
  GG: 'EUR',
  GI: 'EUR',
  HU: 'EUR',
  IM: 'EUR',
  IS: 'EUR',
  JE: 'EUR',
  LI: 'EUR',
  MC: 'EUR',
  MD: 'EUR',
  ME: 'EUR',
  MK: 'EUR',
  NO: 'EUR',
  PL: 'EUR',
  RO: 'EUR',
  RS: 'EUR',
  RU: 'EUR',
  SE: 'EUR',
  SJ: 'EUR',
  UA: 'EUR',
  XK: 'EUR',
  MX: 'MXN',
  ZA: 'ZAR',
  IN: 'INR',
  KR: 'KRW',
  JP: 'JPY',
  PH: 'PHP',
  MY: 'MYR',
  AE: 'AED',
};

export const CurrencyWithSubscriptionPrice = {
  USD: {
    // starter: {
    //   monthly: 59.95,
    //   quarterly: 119.95,
    //   yearly: 432.0,
    // },
    // standard: {
    //   monthly: 119.95,
    //   quarterly: 239.95,
    //   yearly: 780.0,
    // },
    // enterprise: {
    //   monthly: 390.0,
    //   quarterly: 780.0,
    //   yearly: 2399.0,
    // },
    pro: {
      monthly: 39.0,
      yearly: 109.0,
    },
    expert: {
      monthly: 119.0,
      yearly: 349.0,
    },
  },
  CAD: {
    // starter: {
    //   monthly: 79.95,
    //   quarterly: 159.95,
    //   yearly: 579.95,
    // },
    // standard: {
    //   monthly: 159.95,
    //   quarterly: 319.95,
    //   yearly: 998.0,
    // },
    // enterprise: {
    //   monthly: 490.0,
    //   quarterly: 980.0,
    //   yearly: 2899.0,
    // },
    pro: {
      monthly: 49.0,
      yearly: 139.0,
    },
    expert: {
      monthly: 159.0,
      yearly: 459.0,
    },
  },
  GBP: {
    // starter: {
    //   monthly: 49.95,
    //   quarterly: 99.95,
    //   yearly: 335.0,
    // },
    // standard: {
    //   monthly: 98.95,
    //   quarterly: 197.95,
    //   yearly: 598.0,
    // },
    // enterprise: {
    //   monthly: 299.0,
    //   quarterly: 599.0,
    //   yearly: 1799.0,
    // },
    pro: {
      monthly: 29.0,
      yearly: 85.0,
    },
    expert: {
      monthly: 90.0,
      yearly: 270.0,
    },
  },
  AUD: {
    // starter: {
    //   monthly: 89.95,
    //   quarterly: 179.95,
    //   yearly: 660.0,
    // },
    // standard: {
    //   monthly: 179.95,
    //   quarterly: 359.95,
    //   yearly: 1190.0,
    // },
    // enterprise: {
    //   monthly: 550.0,
    //   quarterly: 1100.0,
    //   yearly: 3300.0,
    // },
    pro: {
      monthly: 59.0,
      yearly: 165.0,
    },
    expert: {
      monthly: 179.0,
      yearly: 529.0,
    },
  },
  EUR: {
    // starter: {
    //   monthly: 54.0,
    //   quarterly: 108.0,
    //   yearly: 393.0,
    // },
    // standard: {
    //   monthly: 109.0,
    //   quarterly: 218.0,
    //   yearly: 698.0,
    // },
    // enterprise: {
    //   monthly: 350.0,
    //   quarterly: 700.0,
    //   yearly: 2100.0,
    // },
    pro: {
      monthly: 35.0,
      yearly: 99.0,
    },
    expert: {
      monthly: 109.0,
      yearly: 319.0,
    },
  },
  MXN: {
    // starter: {
    //   monthly: 899.95,
    //   quarterly: 1799.95,
    //   yearly: 6641.0,
    // },
    // standard: {
    //   monthly: 1799.95,
    //   quarterly: 3599.95,
    //   yearly: 11990.0,
    // },
    // enterprise: {
    //   monthly: 5900.0,
    //   quarterly: 11800.0,
    //   yearly: 35400.0,
    // },
    pro: {
      monthly: 699.0,
      yearly: 1899.0,
    },
    expert: {
      monthly: 1999.0,
      yearly: 5799.0,
    },
  },
  ZAR: {
    // starter: {
    //   monthly: 998.0,
    //   quarterly: 1999.0,
    //   yearly: 7368.0,
    // },
    // standard: {
    //   monthly: 1995.0,
    //   quarterly: 3990.0,
    //   yearly: 13303.0,
    // },
    // enterprise: {
    //   monthly: 6999.0,
    //   quarterly: 13999.0,
    //   yearly: 41999.0,
    // },
    pro: {
      monthly: 729.0,
      yearly: 1999.0,
    },
    expert: {
      monthly: 1999.0,
      yearly: 5799.0,
    },
  },
  INR: {
    // starter: {
    //   monthly: 4467.0,
    //   quarterly: 8999,
    //   yearly: 32193.0,
    // },
    // standard: {
    //   monthly: 8939.0,
    //   quarterly: 17899,
    //   yearly: 58126.0,
    // },
    // enterprise: {
    //   monthly: 29999.0,
    //   quarterly: 59999.0,
    //   yearly: 179999.0,
    // },
    pro: {
      monthly: 3199.0,
      yearly: 8999.0,
    },
    expert: {
      monthly: 9999.0,
      yearly: 28999.0,
    },
  },
  KRW: {
    // starter: {
    //   monthly: 69000.0,
    //   quarterly: 138000.0,
    //   yearly: 510106.0,
    // },
    // standard: {
    //   monthly: 139000.0,
    //   quarterly: 278000.0,
    //   yearly: 921024.0,
    // },
    // enterprise: {
    //   monthly: 529999.0,
    //   quarterly: 1059999.0,
    //   yearly: 3179999.0,
    // },
    pro: {
      monthly: 52999.0,
      yearly: 148999.0,
    },
    expert: {
      monthly: 165000.0,
      yearly: 479000.0,
    },
  },
  JPY: {
    // starter: {
    //   monthly: 7600.0,
    //   quarterly: 15200.0,
    //   yearly: 55598.0,
    // },
    // standard: {
    //   monthly: 15438.0,
    //   quarterly: 30899.0,
    //   yearly: 100386.0,
    // },
    // enterprise: {
    //   monthly: 59999.0,
    //   quarterly: 119999.0,
    //   yearly: 359999.0,
    // },
    pro: {
      monthly: 5999.0,
      yearly: 16799.0,
    },
    expert: {
      monthly: 18499.0,
      yearly: 53599.0,
    },
  },
  PHP: {
    // starter: {
    //   monthly: 2900.0,
    //   quarterly: 5800.0,
    //   yearly: 21882.0,
    // },
    // standard: {
    //   monthly: 5990.0,
    //   quarterly: 11999.0,
    //   yearly: 39509.0,
    // },
    // enterprise: {
    //   monthly: 22500.0,
    //   quarterly: 45000.0,
    //   yearly: 135000.0,
    // },
    pro: {
      monthly: 2199.0,
      yearly: 6159.0,
    },
    expert: {
      monthly: 6999.0,
      yearly: 20299.0,
    },
  },
  MYR: {
    // starter: {
    //   monthly: 247.0,
    //   quarterly: 495.0,
    //   yearly: 1777.0,
    // },
    // standard: {
    //   monthly: 493.0,
    //   quarterly: 999.0,
    //   yearly: 3208.0,
    // },
    // enterprise: {
    //   monthly: 1799.0,
    //   quarterly: 3599.0,
    //   yearly: 10799.0,
    // },
    pro: {
      monthly: 179.0,
      yearly: 499.0,
    },
    expert: {
      monthly: 559.0,
      yearly: 1620.0,
    },
  },
  AED: {
    // starter: {
    //   monthly: 198.0,
    //   quarterly: 399.0,
    //   yearly: 1427.0,
    // },
    // standard: {
    //   monthly: 396.0,
    //   quarterly: 789.0,
    //   yearly: 2576.0,
    // },
    // enterprise: {
    //   monthly: 1400.0,
    //   quarterly: 2800.0,
    //   yearly: 8400.0,
    // },
    pro: {
      monthly: 139.0,
      yearly: 389.0,
    },
    expert: {
      monthly: 435.0,
      yearly: 1260.0,
    },
  },
};

export const EuropeCountryCodes = [
  'AD',
  'AL',
  'AT',
  'AX',
  'BA',
  'BE',
  'BG',
  'BY',
  'CH',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FO',
  'FR',
  'GB',
  'GG',
  'GI',
  'GR',
  'HR',
  'HU',
  'IE',
  'IM',
  'IS',
  'IT',
  'JE',
  'LI',
  'LT',
  'LU',
  'LV',
  'MC',
  'MD',
  'ME',
  'MK',
  'MT',
  'NL',
  'NO',
  'PL',
  'PT',
  'RO',
  'RS',
  'RU',
  'SE',
  'SI',
  'SJ',
  'SK',
  'UA',
  'XK',
];

export const rentalArbitrageCalculatorInputFields = [
  {
    key: 'monthlyRent',
    label: 'Monthly Rent',
    tooltip: 'Rent to be paid for the long term lease to the landlord.',
    input: true,
  },
  {
    key: 'monthlyExpense',
    label: 'Monthly Expense',
    tooltip:
      'In your monthly expense you can count in things like Utilities, Bills, Subscriptions and Cleaning Fees. These are recurring expenses that you are liable to pay every month. You can also factor in additional state or country wise charges that you have to pay to your local authorities.',
    input: true,
  },
  {
    key: 'oneTimeCost',
    label: 'One-time Cost',
    tooltip:
      'Apart from paying for your rent, you’ll need to take into account other starting costs like Furnishing, Deposit, Insurance, Appliances, Legal Paperwork and Refurbishing. ',
    input: true,
  },
];

export const exchangeRates = {
  USD: {
    symbol: '$',
    rate: 1,
  },
  CAD: {
    symbol: 'C$',
    rate: 1.34,
  },
  GBP: {
    symbol: '£',
    rate: 0.79,
  },
  EUR: {
    symbol: '€',
    rate: 0.92,
  },
  AUD: {
    symbol: 'A$',
    rate: 1.51,
  },
  BRL: {
    symbol: 'R$',
    rate: 4.92,
  },
  ZAR: {
    symbol: 'R',
    rate: 19.13,
  },
  MXN: {
    symbol: 'MX$',
    rate: 17.36,
  },
  INR: {
    symbol: '₹',
    rate: 82.75,
  },
  KRW: {
    symbol: '₩',
    rate: 1305.74,
  },
  JPY: {
    symbol: '¥',
    rate: 143.24,
  },
  PHP: {
    symbol: '₱',
    rate: 55.62,
  },
  MYR: {
    symbol: 'RM',
    rate: 4.67,
  },
  AED: {
    symbol: 'AED',
    rate: 3.67,
  },
};

// default for LockedDigestCard is estimator Dashboard page

const estimatorDummyRevenueGraphData = [
  { date: '2021-03', revenue: 2962 },
  { date: '2021-04', revenue: 3107 },
  { date: '2021-05', revenue: 3298 },
  { date: '2021-06', revenue: 4003 },
  { date: '2021-07', revenue: 3712 },
  { date: '2021-08', revenue: 3901 },
  { date: '2021-09', revenue: 3937 },
  { date: '2021-10', revenue: 2858 },
  { date: '2021-11', revenue: 3185 },
  { date: '2021-12', revenue: 3319 },
  { date: '2022-01', revenue: 2200 },
  { date: '2022-02', revenue: 3223 },
];

const estimatorDummyNightlyRateGraphData = [
  { date: '2021-03', adr: 208 },
  { date: '2021-04', adr: 237 },
  { date: '2021-05', adr: 213 },
  { date: '2021-06', adr: 260 },
  { date: '2021-07', adr: 258 },
  { date: '2021-08', adr: 213 },
  { date: '2021-09', adr: 212 },
  { date: '2021-10', adr: 209 },
  { date: '2021-11', adr: 214 },
  { date: '2021-12', adr: 264 },
  { date: '2022-01', adr: 231 },
  { date: '2022-02', adr: 234 },
];

const estimatorDummyOccupancyRateGraphData = [
  { date: '2021-03', occupancy_rate: 38 },
  { date: '2021-04', occupancy_rate: 39 },
  { date: '2021-05', occupancy_rate: 40 },
  { date: '2021-06', occupancy_rate: 49 },
  { date: '2021-07', occupancy_rate: 48 },
  { date: '2021-08', occupancy_rate: 50 },
  { date: '2021-09', occupancy_rate: 57 },
  { date: '2021-10', occupancy_rate: 39 },
  { date: '2021-11', occupancy_rate: 43 },
  { date: '2021-12', occupancy_rate: 46 },
  { date: '2022-01', occupancy_rate: 32 },
  { date: '2022-02', occupancy_rate: 41 },
];

export const dummyEstimatorData = {
  revenue: estimatorDummyRevenueGraphData,
  adr: estimatorDummyNightlyRateGraphData,
  occupancy_rate: estimatorDummyOccupancyRateGraphData,
};

const sampleListArray = [
  'full',
  51477180,
  'Lovely Palo Alto 2BR w/ Gym, Pool, 3 min drive to Stanford, by Blueground',
  'prohost-api/Hosting-51477180/original/18da5a97-3943-4710-98e8-5274bdbe31aa.jpeg',
  37.43,
  -122.189,
  'entire_home',
  '-1',
  '2',
  2,
  4,
  'Blueground',
  30,
  null,
  405,
  0,
  0,
  't',
  'f',
  'f',
  'f',
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -317,
  -339,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  0,
  0,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  0,
  0,
  304,
  't',
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  't',
  't',
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  0,
  0,
  16.666666666666664,
];

export const sampleListings = [...new Array(8)].map(curr => [...sampleListArray]);

export const dummyImageLinks = [
  'ddb5755b-db1b-4ccd-af2f-b0b3a470148b.jpg',
  'prohost-api/Hosting-50152739/original/e4601d2c-dacd-40e8-81a4-db15da689bbc.jpeg',
  '670a55b3-62d8-4f3f-a604-b31ee0d5f6c7.jpg',
  'miso/Hosting-53688023/original/bc0d43b8-e112-467c-9bf6-de05a4821c56.jpeg',
  '37059356/9d618934_original.jpg',
  'e37ea637-6f09-4b67-b11d-8992c02a50f2.jpg',
  '24158910/60281de7_original.jpg',
];

export let InvestmentSimulationWizardInputKeys = [
  {
    key: 'propertyDetails',
    label: '',
    step: 1,
    header: '',
    substep: '1',
    question: `Great, let's grab your property details so we can simulate your return on investment!`,
    hint: '',
    inputType: 'step',
    placeholder: '',
    unit: '',
    hide: false,
    required: false,
  },
  {
    key: 'propertyPrice',
    label: 'Property Price',
    step: 1,
    header: `Great, Let's grab your property details so we can simulate your return on investement!`,
    substep: 'a',
    question: 'Important question, what is your estimated *property price*?',
    hint: '',
    inputType: 'number',
    placeholder: '',
    unit: '$',
    hide: false,
    required: true,
  },
  {
    key: 'takingLoan',
    label: 'Loan taken',
    step: 1,
    header: `Great, Let's grab your property details so we can simulate your return on investement!`,
    substep: 'a',
    question: 'Are you paying *Mortgage* for this property?',
    hint: '',
    inputType: 'boolean',
    placeholder: '',
    unit: '',
    hide: false,
    required: true,
  },
  {
    key: 'downPayment',
    label: 'Down Payment',
    step: 1,
    header: `Great, Let's grab your property details so we can simulate your return on investement!`,
    substep: 'b',
    question: 'What is your estimated *down payment* for this property?',
    hint: '',
    inputType: 'number',
    placeholder: '',
    unit: '$',
    hide: false,
    required: true,
  },
  {
    key: 'loanTerm',
    label: 'Loan Term',
    step: 1,
    header: `Great, Let's grab your property details so we can simulate your return on investement!`,
    substep: 'c',
    question: 'How long is your loan term?',
    hint: '',
    inputType: 'loanTerm',
    placeholder: '',
    unit: '$',
    hide: false,
    required: true,
  },
  {
    key: 'interestRate',
    label: 'Interest Rate',
    step: 1,
    header: `Great, Let's grab your property details so we can simulate your return on investement!`,
    substep: 'd',
    question: "What's the interest rate?",
    hint: '',
    inputType: 'number',
    placeholder: '',
    unit: '%',
    hide: false,
    required: true,
  },
  // {
  //   key: 'mortgageFees',
  //   label: 'Mortgage Fees',
  //   step: 1,
  //   header: `Great, Let's grab your property details so we can simulate your return on investement!`,
  //   substep: 'e',
  //   question: 'What is your estimated monthly payment to your mortgage provider?',
  //   hint:
  //     'Visit [here](https://www.bankrate.com/mortgages/mortgage-calculator/) if you are unsure how to calculate this',
  //   inputType: 'number',
  //   placeholder: '',
  //   unit: '$',
  //   hide: false,
  //   required: false,
  // },
  {
    key: 'closingCosts',
    label: 'Closing Costs',
    step: 1,
    header: `Great, Let's grab your property details so we can simulate your return on investement!`,
    substep: 'e',
    question: 'Thanks for that, how much do you expect to spend on closing costs?',
    hint: `Closing costs typically range from 3%-6% of the home's purchase price. It includes taxes, legal, property transaction fees etc`,
    inputType: 'number',
    placeholder: '',
    unit: '$',
    hide: false,
    required: false,
  },
  {
    key: 'homeFurnishings',
    label: 'Home Furnishings',
    step: 1,
    header: `Great, Let's grab your property details so we can simulate your return on investement!`,
    substep: 'f',
    question: 'How much do you expect to pay for *furnishing* your new place?',
    hint: 'Put 0 if you already have a house prepared for renting out.',
    inputType: 'number',
    placeholder: '',
    unit: '$',
    hide: false,
    required: false,
  },
  {
    key: 'monthlyExpenses',
    label: '',
    step: 2,
    header: '',
    substep: '2',
    question: `Thank you :) Let's understand your monthly expenses. It'll be quick!`,
    hint: '',
    inputType: 'step',
    placeholder: '',
    unit: '',
    hide: false,
    required: false,
  },
  {
    key: 'electricity',
    label: 'Electricity',
    step: 2,
    header: `Thank you :) Let's understand your monthly expenses. It'll be quick!`,
    substep: 'a',
    question: 'How much do you expect to pay for *electricity* every month?',
    hint: 'Not sure? Use our magic number @MN',
    inputType: 'number',
    placeholder: '73',
    unit: '$',
    hide: false,
    required: false,
  },
  {
    key: 'wifi',
    label: 'Wifi',
    step: 2,
    header: `Thank you :) Let's understand your monthly expenses. It'll be quick!`,
    substep: 'b',
    question: 'How much do you expect to pay for *wifi* every month?',
    hint: 'Not sure? Use our magic number @MN',
    inputType: 'number',
    placeholder: '35',
    unit: '$',
    hide: false,
    required: false,
  },
  {
    key: 'gas',
    label: 'Gas',
    step: 2,
    header: `Thank you :) Let's understand your monthly expenses. It'll be quick!`,
    substep: 'c',
    question: 'How much do you expect to pay for *gas* every month?',
    hint: 'Not sure? Use our magic number @MN',
    inputType: 'number',
    placeholder: '43',
    unit: '$',
    hide: false,
    required: false,
  },
  {
    key: 'annualExpenses',
    label: '',
    step: 3,
    header: '',
    substep: '3',
    question: `Almost there! Let's grab your annual expenses.`,
    hint: '',
    inputType: 'step',
    placeholder: '',
    unit: '',
    hide: false,
    required: false,
  },
  {
    key: 'willUseManagementCompany',
    label: '',
    step: 3,
    header: `Almost there! Let's grab your annual expenses.`,
    substep: 'a',
    question: 'Will you use a *management company*?',
    hint: 'No, if you are going to manage yourself',
    inputType: 'boolean',
    placeholder: '',
    unit: '',
    hide: false,
    required: false,
  },
  {
    key: 'managementFee',
    label: 'Management Fee',
    step: 3,
    header: `Almost there! Let's grab your annual expenses.`,
    substep: 'b',
    question: 'How much percentage does your management company take from your revenue?',
    hint: 'Typically, the standard fees that we see are ranging from 15 - 35%.',
    inputType: 'number',
    placeholder: '20',
    unit: '%',
    hide: true,
    required: false,
  },
  {
    key: 'propertyTax',
    label: 'Property Tax',
    step: 3,
    header: `Almost there! Let's grab your annual expenses.`,
    substep: 'c',
    question: 'How much *property tax* do you need to pay? (Annual)',
    hint: `It's a tax paid on property owned by an individual or a corporation. For US properties, include both county and country property taxes`,
    inputType: 'number',
    placeholder: '10',
    unit: '%',
    hide: false,
    required: false,
  },
  {
    key: 'lodgingTax',
    label: 'Lodgning Tax',
    step: 3,
    header: `Almost there! Let's grab your annual expenses.`,
    substep: 'd',
    question: 'How much *lodging tax* do you need to pay? (Annual)',
    hint: '',
    inputType: 'number',
    placeholder: '5',
    unit: '%',
    hide: false,
    required: false,
  },
  {
    key: 'maintenance',
    label: 'Maintenance',
    step: 3,
    header: `Almost there! Let's grab your annual expenses.`,
    substep: 'e',
    question: 'How much do you expect to pay for *maintenance*? (Annual)',
    hint:
      'Things you need to think about: HOA fees, Reparis & Maintenance, Travel expenses.. Not sure? Tip! $2,319 a year is an average maintenance costs among our users.',
    inputType: 'number',
    placeholder: '2,319',
    unit: '$',
    hide: false,
    required: false,
  },
  {
    key: 'insurance',
    label: 'Insurance',
    step: 3,
    header: `Almost there! Let's grab your annual expenses.`,
    substep: 'f',
    question: 'How much do you expect to pay for *insurance*? (Annual)',
    hint: 'Tip! $1,765 a year is an average homeowner insurance costs in the US',
    inputType: 'number',
    placeholder: '1,765',
    unit: '$',
    hide: false,
    required: false,
  },
  {
    key: 'other',
    label: 'Other',
    step: 3,
    header: `Almost there! Let's grab your annual expenses.`,
    substep: 'g',
    question: `This is the last chance to put your remaining expenses. If there are any expenses that you haven't filled in the previous step, please add them and put the annaul sum here.`,
    hint: `If you are sure you've put all the expenses, just put 0!`,
    inputType: 'number',
    placeholder: '',
    unit: '$',
    hide: false,
    required: false,
  },
  {
    key: 'summary',
    label: '',
    step: 4,
    header: `Summing it up!`,
    substep: '',
    question: '',
    hint: '',
    inputType: '',
    unit: '',
    hide: false,
    required: false,
  },
];

export const investmentCalInputKeys = {
  annualRevenue: {
    key: 'revenuePotential',
    label: 'Revenue Projection',
    tooltip: '',
  },
  annualExpenses: {
    key: 'annualExpenses',
    label: 'Annual Expenses',
    tooltip:
      'The expected annual recurring expenses. The annual expenses typically include Short-term rental license fees, Home Owner Association (HOA) fees, and insurance.',
    subfields: [
      {
        key: 'managementFee',
        label: 'Management Fee',
        unit: '%',
      },
      {
        key: 'propertyTax',
        label: 'Property Tax',
        unit: '%',
      },
      {
        key: 'lodgingTax',
        label: 'Lodgning Tax',
        unit: '%',
      },
      {
        key: 'mortgageFees',
        label: 'Mortgage Fee (Monthly)',
        unit: '$',
      },
      {
        key: 'hoaFees',
        label: 'HOA Fee (Annual)',
        unit: '$',
      },
      {
        key: 'maintenance',
        label: 'Maintenance (Annual)',
        unit: '$',
      },
      {
        key: 'insurance',
        label: 'Insurance (Annual)',
        unit: '$',
      },
      {
        key: 'electricity',
        label: 'Electricity (Monthly)',
        unit: '$',
      },
      {
        key: 'wifi',
        label: 'Wifi (Monthly)',
        unit: '$',
      },
      {
        key: 'gas',
        label: 'Gas (Monthly)',
        unit: '$',
      },
      {
        key: 'other',
        label: 'Others (Annual)',
        unit: '$',
      },
    ],
  },
  propertyPrice: {
    key: 'propertyPrice',
    label: 'Property Price',
    tooltip: `The property price of a property that you'd like to simulate profit for.`,
    input: true,
    unit: '$',
    subfields: [
      {
        key: 'downPayment',
        label: 'Down Payment',
        unit: '$',
      },
    ],
  },
  startupCosts: {
    key: 'startupCosts',
    label: 'Startup Costs',
    tooltip: `It's the cost that occurs only once to get started with your short-term rentals. The startup costs typically include refurbishment fee and closing costs.`,
    subfields: [
      {
        key: 'homeFurnishings',
        label: 'Home Furnishings',
        unit: '$',
      },
      {
        key: 'closingCosts',
        label: 'Closing Costs',
        unit: '$',
      },
    ],
  },
};

export const Top10ManagerDummyData = [
  {
    id: 9802857,
    name: 'My Getaways',
    revenue: 2872414,
    listings: 80,
    image:
      'https://a0.muscache.com/im/pictures/prohost-api/Hosting-14710163/original/fd4a9550-4de3-4f45-a80e-aedbcfaab98b.jpeg?aki_policy=small',
    avgRating: 4.37,
  },
  {
    id: 183539480,
    name: 'Airhost For You',
    revenue: 1934068,
    listings: 77,
    image:
      'https://a0.muscache.com/im/pictures/prohost-api/Hosting-24750876/original/884969e7-3530-47e4-8877-55ac8bf63c23.jpeg?aki_policy=small',
    avgRating: 4.61,
  },
  {
    id: 116513439,
    name: 'Original Cottages Kent & Sussex',
    revenue: 1627675,
    listings: 22,
    image:
      'https://a0.muscache.com/im/pictures/prohost-api/Hosting-22543520/original/340c6105-15f4-4468-bd9e-c69784722a99.jpeg?aki_policy=small',
    avgRating: 3.27,
  },
  {
    id: 298960871,
    name: 'Blok-Brighton',
    revenue: 1093324,
    listings: 24,
    image:
      'https://a0.muscache.com/im/pictures/5a1e2b9d-f8fc-4c46-989b-cc88272102b0.jpg?aki_policy=small',
    avgRating: 4.7,
  },
  {
    id: 402695524,
    name: 'Francesca',
    revenue: 1031222,
    listings: 31,
    image:
      'https://a0.muscache.com/im/pictures/487053ed-efec-4c45-8d27-60d00031d47b.jpg?aki_policy=small',
    avgRating: 4.61,
  },
  {
    id: 96169037,
    name: 'Brighton Holiday Lets',
    revenue: 1009010,
    listings: 40,
    image:
      'https://a0.muscache.com/im/pictures/prohost-api/Hosting-15201823/original/4d457ff0-a33f-4881-bfaf-74da2bbe1c1c.jpeg?aki_policy=small',
    avgRating: 4.58,
  },
  {
    id: 44243335,
    name: 'Crown Gardens Holiday Homes',
    revenue: 823421,
    listings: 22,
    image:
      'https://a0.muscache.com/im/pictures/prohost-api/Hosting-8280138/original/28e94ac3-5f72-41b7-8d63-5a0e44c8a243.jpeg?aki_policy=small',
    avgRating: 3.45,
  },
  {
    id: 190150800,
    name: 'Creatick',
    revenue: 781499,
    listings: 30,
    image:
      'https://a0.muscache.com/im/pictures/63553543-8c09-4fd5-9289-1232afababea.jpg?aki_policy=small',
    avgRating: 4.57,
  },
  {
    id: 279714013,
    name: 'Terry',
    revenue: 754031,
    listings: 61,
    image:
      'https://a0.muscache.com/im/pictures/prohost-api/Hosting-37902650/original/83dc4bf2-8cc4-4771-a09f-31ed3959babb.jpeg?aki_policy=small',
    avgRating: 3.9,
  },
  {
    id: 394289502,
    name: 'Sharphaus',
    revenue: 681018,
    listings: 24,
    image:
      'https://a0.muscache.com/im/pictures/miso/Hosting-48924856/original/11686a59-7902-4a0f-991a-545c3b435d19.jpeg?aki_policy=small',
    avgRating: 4.04,
  },
];

// Sample Data for Insights Dashboard

export const sampleOccupancyRateData: OccupancyRate[] = [
  { date: '2020-09', occupancy_rate: 58 },
  { date: '2020-10', occupancy_rate: 58 },
  { date: '2020-11', occupancy_rate: 56 },
  { date: '2020-12', occupancy_rate: 54 },
  { date: '2021-01', occupancy_rate: 53 },
  { date: '2021-02', occupancy_rate: 54 },
  { date: '2021-03', occupancy_rate: 56 },
  { date: '2021-04', occupancy_rate: 62 },
  { date: '2021-05', occupancy_rate: 66 },
  { date: '2021-06', occupancy_rate: 68 },
  { date: '2021-07', occupancy_rate: 71 },
  { date: '2021-08', occupancy_rate: 71 },
];

export const sampleMedianNightlyRateData: ADR[] = [
  { date: '2020-09', adr: 168 },
  { date: '2020-10', adr: 170 },
  { date: '2020-11', adr: 169 },
  { date: '2020-12', adr: 172 },
  { date: '2021-01', adr: 170 },
  { date: '2021-02', adr: 172 },
  { date: '2021-03', adr: 180 },
  { date: '2021-04', adr: 189 },
  { date: '2021-05', adr: 201 },
  { date: '2021-06', adr: 212 },
  { date: '2021-07', adr: 216 },
  { date: '2021-08', adr: 222 },
];

export const sampleRevenueData: Revenue[] = [
  { date: '2020-09', revenue: 3158 },
  { date: '2020-10', revenue: 3214 },
  { date: '2020-11', revenue: 3082 },
  { date: '2020-12', revenue: 3065 },
  { date: '2021-01', revenue: 2992 },
  { date: '2021-02', revenue: 3075 },
  { date: '2021-03', revenue: 3296 },
  { date: '2021-04', revenue: 3659 },
  { date: '2021-05', revenue: 4171 },
  { date: '2021-06', revenue: 4580 },
  { date: '2021-07', revenue: 4962 },
  { date: '2021-08', revenue: 5154 },
];

export const sampleMarketTrendData = {
  '2018': 27,
  '2019': 26,
  '2020': 12,
  '2021': 13,
};

export const dummyPropertySizeBarGraphData: BarGraphData[] = [
  {
    keyShort: 'Studio',
    keyLong: 'Studio',
    value: 4,
  },
  {
    keyShort: '1',
    keyLong: '1 bedroom',
    value: 4,
  },
  {
    keyShort: '2',
    keyLong: '2 bedrooms',
    value: 11,
  },
  {
    keyShort: '3',
    keyLong: '3 bedrooms',
    value: 9,
  },
  {
    keyShort: '4',
    keyLong: '4 bedrooms',
    value: 14,
  },
  {
    keyShort: '5',
    keyLong: '5 bedrooms',
    value: 24,
  },
  {
    keyShort: '6+',
    keyLong: '6+ bedrooms',
    value: 31,
  },
  {
    keyShort: 'rooms',
    keyLong: 'private/hotel/shared rooms',
    value: 3,
  },
];

export const dummyPieChartData: PieChartData[] = [
  { name: 'Entire Home', value: 43, percentage: 43, legend: 'E' },
  { name: 'Condo', value: 17, percentage: 17, legend: 'C' },
  { name: 'Private Room', value: 12, percentage: 12, legend: 'P' },
  { name: 'Hotel Room', value: 24, percentage: 24, legend: 'H' },
  { name: 'Shared Room', value: 3, percentage: 3, legend: 'S' },
];

export const dummyBookingTypeBarGraphData: BarGraphData[] = [
  {
    keyLong: 'Multiple Nights',
    value: 55,
  },
  {
    keyLong: 'Single Night',
    value: 33,
  },
  {
    keyLong: 'Weekly',
    value: 7,
  },
  {
    keyLong: 'Mid-term',
    value: 4,
  },
];

export const dummyBookingLeadBarGraphData: BarGraphData[] = [
  {
    keyLong: 'Advanced',
    value: 74,
  },
  {
    keyLong: 'Normal',
    value: 20,
  },
  {
    keyLong: 'Last-minute',
    value: 6,
  },
];

export const sampleMarket = 'the city of brighton and hove';
// export const sampleEstimatorMarket = 'Sand Hill Road, Menlo Park, CA, USA';
// export const sampleEstimatorCenterCoord = { lat: 37.4209955, lng: -122.2071039 };
export const sampleDiscoveryAddress = 'Miami, FL, USA';

export const mapPadding = {
  bottom: 10,
  left: 10,
  right: 10,
  top: 10,
};

export const DYNAMIC_PRICING_ANALYTICS_MIXPANEL_TOKEN = 'f6e0ab2f76279e5f77ee98e743c2ca03';

export const timePreiodNumberNameMap = {
  100: 'All-History',
  12: '12-Months',
  6: '6-Months',
};

export const percentageNumberNameMap = {
  0.9: 'Top-10%',
  0.5: 'Top-50%',
  0.75: 'Top-25%',
};

export const NOT_VERIFIED_USER_ALLOWED_INVESTMENT_ESTIMATOR_SEARCH_ATTEMPTS = 3;

export const DOWNLOAD_CSV_LISTINGS_LTM_DATA = 'Individual listing’s LTM data';
export const DOWNLOAD_CSV_KEY_METRICS = 'Key Metrics by Property Size';
export const DISCOVERY_TOOL_VIDEO_TUTORIAL_LINK = 'https://youtu.be/qrMX_z5LXLU';

export const CLUSTER_POINTER_ZOOM_LEVEL_THRESHOLD = 12;

export const secondUserDescriptionMap = {
  property_investor: {
    'How many properties will you purchase in the next 12 months?': [
      '1 - 5 properties',
      '5 - 20 properties',
      '20+ properties',
    ],
  },
  property_manager: {
    'How many Airbnb listings do you currently manage?': [
      '0 listing',
      '1 - 5 listings',
      '5 - 20 listings',
      '20+ listings',
    ],
  },
};

export const daysInMonth = (isLeapYear: boolean, monthObject: boolean = false) => {
  if (monthObject) {
    return {
      january: 31,
      february: isLeapYear ? 29 : 28,
      march: 31,
      april: 30,
      may: 31,
      june: 30,
      july: 31,
      august: 31,
      september: 30,
      october: 31,
      november: 30,
      december: 31,
    };
  }
  return [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
};

export const fuseSearchOptions = {
  includeMatchers: true,
  useExtendedSearch: true,
  includeScore: true,
  shouldSort: true,
  findAllMatches: true,
  keys: [
    {
      name: 'district',
      weight: 10,
    },
    {
      name: 'city',
      weight: 0.5,
    },
    {
      name: 'country',
      weight: 0.5,
    },
  ],
};

export const TOP_BANNER_PADDING = '60px';
export const TOP_BANNER_PADDING_MOBILE = '100px';
export const AIRBTICS_PRO_BANNER_LOCALSTORAGE_VARIABLE = 'is-top-banner-airbtics-pro-shown';

export const countryListWithCode = [
  { code: 'AF', label: 'Afghanistan ' },
  { code: 'AL', label: 'Albania ' },
  { code: 'DZ', label: 'Algeria ' },
  { code: 'AS', label: 'American Samoa ' },
  { code: 'AD', label: 'Andorra ' },
  { code: 'AO', label: 'Angola ' },
  { code: 'AI', label: 'Anguilla ' },
  { code: 'AQ', label: 'Antarctica ' },
  { code: 'AG', label: 'Antigua and Barbuda ' },
  { code: 'AR', label: 'Argentina ' },
  { code: 'AM', label: 'Armenia ' },
  { code: 'AW', label: 'Aruba ' },
  { code: 'AU', label: 'Australia ' },
  { code: 'AT', label: 'Austria ' },
  { code: 'AZ', label: 'Azerbaijan ' },
  { code: 'BS', label: 'Bahamas ' },
  { code: 'BH', label: 'Bahrain ' },
  { code: 'BD', label: 'Bangladesh ' },
  { code: 'BB', label: 'Barbados ' },
  { code: 'BY', label: 'Belarus ' },
  { code: 'BE', label: 'Belgium ' },
  { code: 'BZ', label: 'Belize ' },
  { code: 'BJ', label: 'Benin ' },
  { code: 'BM', label: 'Bermuda ' },
  { code: 'BT', label: 'Bhutan ' },
  { code: 'BO', label: 'Bolivia (Plurinational State of) ' },
  { code: 'BQ', label: 'Bonaire, Sint Eustatius and Saba ' },
  { code: 'BA', label: 'Bosnia and Herzegovina ' },
  { code: 'BW', label: 'Botswana ' },
  { code: 'BV', label: 'Bouvet Island ' },
  { code: 'BR', label: 'Brazil ' },
  { code: 'IO', label: 'British Indian Ocean Territory ' },
  { code: 'BN', label: 'Brunei Darussalam ' },
  { code: 'BG', label: 'Bulgaria ' },
  { code: 'BF', label: 'Burkina Faso ' },
  { code: 'BI', label: 'Burundi ' },
  { code: 'CV', label: 'Cabo Verde ' },
  { code: 'KH', label: 'Cambodia ' },
  { code: 'CM', label: 'Cameroon ' },
  { code: 'CA', label: 'Canada ' },
  { code: 'KY', label: 'Cayman Islands ' },
  { code: 'CF', label: 'Central African Republic ' },
  { code: 'TD', label: 'Chad ' },
  { code: 'CL', label: 'Chile ' },
  { code: 'CN', label: 'China ' },
  { code: 'CX', label: 'Christmas Island ' },
  { code: 'CC', label: 'Cocos (Keeling) Islands ' },
  { code: 'CO', label: 'Colombia ' },
  { code: 'KM', label: 'Comoros ' },
  { code: 'CD', label: 'Congo (the Democratic Republic of the) ' },
  { code: 'CG', label: 'Congo ' },
  { code: 'CK', label: 'Cook Islands ' },
  { code: 'CR', label: 'Costa Rica ' },
  { code: 'HR', label: 'Croatia ' },
  { code: 'CU', label: 'Cuba ' },
  { code: 'CW', label: 'Curaçao ' },
  { code: 'CY', label: 'Cyprus ' },
  { code: 'CZ', label: 'Czechia ' },
  { code: 'CI', label: "Côte d'Ivoire " },
  { code: 'DK', label: 'Denmark ' },
  { code: 'DJ', label: 'Djibouti ' },
  { code: 'DM', label: 'Dominica ' },
  { code: 'DO', label: 'Dominican Republic ' },
  { code: 'EC', label: 'Ecuador ' },
  { code: 'EG', label: 'Egypt ' },
  { code: 'SV', label: 'El Salvador ' },
  { code: 'GQ', label: 'Equatorial Guinea ' },
  { code: 'ER', label: 'Eritrea ' },
  { code: 'EE', label: 'Estonia ' },
  { code: 'SZ', label: 'Eswatini ' },
  { code: 'ET', label: 'Ethiopia ' },
  { code: 'FK', label: 'Falkland Islands  [Malvinas] ' },
  { code: 'FO', label: 'Faroe Islands ' },
  { code: 'FJ', label: 'Fiji ' },
  { code: 'FI', label: 'Finland ' },
  { code: 'FR', label: 'France ' },
  { code: 'GF', label: 'French Guiana ' },
  { code: 'PF', label: 'French Polynesia ' },
  { code: 'TF', label: 'French Southern Territories ' },
  { code: 'GA', label: 'Gabon ' },
  { code: 'GM', label: 'Gambia ' },
  { code: 'GE', label: 'Georgia ' },
  { code: 'DE', label: 'Germany ' },
  { code: 'GH', label: 'Ghana ' },
  { code: 'GI', label: 'Gibraltar ' },
  { code: 'GR', label: 'Greece ' },
  { code: 'GL', label: 'Greenland ' },
  { code: 'GD', label: 'Grenada ' },
  { code: 'GP', label: 'Guadeloupe ' },
  { code: 'GU', label: 'Guam ' },
  { code: 'GT', label: 'Guatemala ' },
  { code: 'GG', label: 'Guernsey ' },
  { code: 'GN', label: 'Guinea ' },
  { code: 'GW', label: 'Guinea-Bissau ' },
  { code: 'GY', label: 'Guyana ' },
  { code: 'HT', label: 'Haiti ' },
  { code: 'HM', label: 'Heard Island and McDonald Islands ' },
  { code: 'VA', label: 'Holy See ' },
  { code: 'HN', label: 'Honduras ' },
  { code: 'HK', label: 'Hong Kong ' },
  { code: 'HU', label: 'Hungary ' },
  { code: 'IS', label: 'Iceland ' },
  { code: 'IN', label: 'India ' },
  { code: 'ID', label: 'Indonesia ' },
  { code: 'IR', label: 'Iran (Islamic Republic of) ' },
  { code: 'IQ', label: 'Iraq ' },
  { code: 'IE', label: 'Ireland ' },
  { code: 'IM', label: 'Isle of Man ' },
  { code: 'IL', label: 'Israel ' },
  { code: 'IT', label: 'Italy ' },
  { code: 'JM', label: 'Jamaica ' },
  { code: 'JP', label: 'Japan ' },
  { code: 'JE', label: 'Jersey ' },
  { code: 'JO', label: 'Jordan ' },
  { code: 'KZ', label: 'Kazakhstan ' },
  { code: 'KE', label: 'Kenya ' },
  { code: 'KI', label: 'Kiribati ' },
  { code: 'KP', label: "Korea (the Democratic People's Republic of) " },
  { code: 'KR', label: 'Korea (the Republic of) ' },
  { code: 'KW', label: 'Kuwait ' },
  { code: 'KG', label: 'Kyrgyzstan ' },
  { code: 'LA', label: "Lao People's Democratic Republic " },
  { code: 'LV', label: 'Latvia ' },
  { code: 'LB', label: 'Lebanon ' },
  { code: 'LS', label: 'Lesotho ' },
  { code: 'LR', label: 'Liberia ' },
  { code: 'LY', label: 'Libya ' },
  { code: 'LI', label: 'Liechtenstein ' },
  { code: 'LT', label: 'Lithuania ' },
  { code: 'LU', label: 'Luxembourg ' },
  { code: 'MO', label: 'Macao ' },
  { code: 'MG', label: 'Madagascar ' },
  { code: 'MW', label: 'Malawi ' },
  { code: 'MY', label: 'Malaysia ' },
  { code: 'MV', label: 'Maldives ' },
  { code: 'ML', label: 'Mali ' },
  { code: 'MT', label: 'Malta ' },
  { code: 'MH', label: 'Marshall Islands ' },
  { code: 'MQ', label: 'Martinique ' },
  { code: 'MR', label: 'Mauritania ' },
  { code: 'MU', label: 'Mauritius ' },
  { code: 'YT', label: 'Mayotte ' },
  { code: 'MX', label: 'Mexico ' },
  { code: 'FM', label: 'Micronesia (Federated States of) ' },
  { code: 'MD', label: 'Moldova (the Republic of) ' },
  { code: 'MC', label: 'Monaco ' },
  { code: 'MN', label: 'Mongolia ' },
  { code: 'ME', label: 'Montenegro ' },
  { code: 'MS', label: 'Montserrat ' },
  { code: 'MA', label: 'Morocco ' },
  { code: 'MZ', label: 'Mozambique ' },
  { code: 'MM', label: 'Myanmar ' },
  { code: 'NA', label: 'Namibia ' },
  { code: 'NR', label: 'Nauru ' },
  { code: 'NP', label: 'Nepal ' },
  { code: 'NL', label: 'Netherlands ' },
  { code: 'NC', label: 'New Caledonia ' },
  { code: 'NZ', label: 'New Zealand ' },
  { code: 'NI', label: 'Nicaragua ' },
  { code: 'NE', label: 'Niger ' },
  { code: 'NG', label: 'Nigeria ' },
  { code: 'NU', label: 'Niue ' },
  { code: 'NF', label: 'Norfolk Island ' },
  { code: 'MP', label: 'Northern Mariana Islands ' },
  { code: 'NO', label: 'Norway ' },
  { code: 'OM', label: 'Oman ' },
  { code: 'PK', label: 'Pakistan ' },
  { code: 'PW', label: 'Palau ' },
  { code: 'PS', label: 'Palestine ' },
  { code: 'PA', label: 'Panama ' },
  { code: 'PG', label: 'Papua New Guinea ' },
  { code: 'PY', label: 'Paraguay ' },
  { code: 'PE', label: 'Peru ' },
  { code: 'PH', label: 'Philippines ' },
  { code: 'PN', label: 'Pitcairn ' },
  { code: 'PL', label: 'Poland ' },
  { code: 'PT', label: 'Portugal ' },
  { code: 'PR', label: 'Puerto Rico ' },
  { code: 'QA', label: 'Qatar ' },
  { code: 'MK', label: 'Republic of North Macedonia ' },
  { code: 'RO', label: 'Romania ' },
  { code: 'RU', label: 'Russian Federation ' },
  { code: 'RW', label: 'Rwanda ' },
  { code: 'RE', label: 'Réunion ' },
  { code: 'BL', label: 'Saint Barthélemy ' },
  { code: 'SH', label: 'Saint Helena, Ascension and Tristan da Cunha ' },
  { code: 'KN', label: 'Saint Kitts and Nevis ' },
  { code: 'LC', label: 'Saint Lucia ' },
  { code: 'MF', label: 'Saint Martin (French part) ' },
  { code: 'PM', label: 'Saint Pierre and Miquelon ' },
  { code: 'VC', label: 'Saint Vincent and the Grenadines ' },
  { code: 'WS', label: 'Samoa ' },
  { code: 'SM', label: 'San Marino ' },
  { code: 'ST', label: 'Sao Tome and Principe ' },
  { code: 'SA', label: 'Saudi Arabia ' },
  { code: 'SN', label: 'Senegal ' },
  { code: 'RS', label: 'Serbia ' },
  { code: 'SC', label: 'Seychelles ' },
  { code: 'SL', label: 'Sierra Leone ' },
  { code: 'SG', label: 'Singapore ' },
  { code: 'SX', label: 'Sint Maarten (Dutch part) ' },
  { code: 'SK', label: 'Slovakia ' },
  { code: 'SI', label: 'Slovenia ' },
  { code: 'SB', label: 'Solomon Islands ' },
  { code: 'SO', label: 'Somalia ' },
  { code: 'ZA', label: 'South Africa ' },
  { code: 'GS', label: 'South Georgia and the South Sandwich Islands ' },
  { code: 'SS', label: 'South Sudan ' },
  { code: 'ES', label: 'Spain ' },
  { code: 'LK', label: 'Sri Lanka ' },
  { code: 'SD', label: 'Sudan ' },
  { code: 'SR', label: 'Suriname ' },
  { code: 'SJ', label: 'Svalbard and Jan Mayen ' },
  { code: 'SE', label: 'Sweden ' },
  { code: 'CH', label: 'Switzerland ' },
  { code: 'SY', label: 'Syrian Arab Republic ' },
  { code: 'TW', label: 'Taiwan ' },
  { code: 'TJ', label: 'Tajikistan ' },
  { code: 'TZ', label: 'Tanzania, United Republic of ' },
  { code: 'TH', label: 'Thailand ' },
  { code: 'TL', label: 'Timor-Leste ' },
  { code: 'TG', label: 'Togo ' },
  { code: 'TK', label: 'Tokelau ' },
  { code: 'TO', label: 'Tonga ' },
  { code: 'TT', label: 'Trinidad and Tobago ' },
  { code: 'TN', label: 'Tunisia ' },
  { code: 'TR', label: 'Turkey ' },
  { code: 'TM', label: 'Turkmenistan' },
  { code: 'TC', label: 'Turks and Caicos Islands ' },
  { code: 'TV', label: 'Tuvalu ' },
  { code: 'UG', label: 'Uganda ' },
  { code: 'UA', label: 'Ukraine ' },
  { code: 'AE', label: 'United Arab Emirates' },
  { code: 'GB', label: 'United Kingdom' },
  { code: 'UM', label: 'United States Minor Outlying Islands ' },
  { code: 'US', label: 'United States ' },
  { code: 'UY', label: 'Uruguay' },
  { code: 'UZ', label: 'Uzbekistan' },
  { code: 'VU', label: 'Vanuatu' },
  { code: 'VE', label: 'Venezuela (Bolivarian Republic of)' },
  { code: 'VN', label: 'Viet Nam' },
  { code: 'VG', label: 'Virgin Islands (British) ' },
  { code: 'VI', label: 'Virgin Islands (U.S.) ' },
  { code: 'WF', label: 'Wallis and Futuna ' },
  { code: 'EH', label: 'Western Sahara' },
  { code: 'YE', label: 'Yemen ' },
  { code: 'ZM', label: 'Zambia ' },
  { code: 'ZW', label: 'Zimbabwe ' },
  { code: 'AX', label: 'Åland Islands ' },
];

export const AIRBTICS_PRO_PAYMENT_LINK_US = 'https://buy.stripe.com/dR64iN80Q2l54483dO';
export const AIRBTICS_PRO_PAYMENT_LINK_UK = 'https://buy.stripe.com/00geXr6WMcZJ7gkeWx';
export const AIRBTICS_PRO_PAYMENT_LINK_AU = 'https://buy.stripe.com/aEUg1v0yo8Jt7gk4hV';
export const AIRBTICS_PRO_PAYMENT_LINK_CA = 'https://buy.stripe.com/bIY9D7dlaaRB8ko7u6';

export const US_AIRBNB_STATISTICS_DATA_URL =
  'https://airbtics-resource.s3.us-east-2.amazonaws.com/us_marrkets_top_city_data.csv';
export const US_REAL_ESTATE_ANALYSIS_TABLE_DATA_URL =
  'https://airbtics-resource.s3.us-east-2.amazonaws.com/real_estate_investability-5_years_trend.csv';

export const UK_AIRBNB_STATISTICS_DATA_URL =
  'https://airbtics-resource.s3.us-east-2.amazonaws.com/uk_markets_top_city.csv';
export const UK_REAL_ESTATE_ANALYSIS_TABLE_DATA_URL =
  'https://airbtics-resource.s3.us-east-2.amazonaws.com/uk_real_estate_investability-5_years_trend.csv';

export const CA_AIRBNB_STATISTICS_DATA_URL =
  'https://airbtics-resource.s3.us-east-2.amazonaws.com/ca_markets_top_city.csv';
export const CA_REAL_ESTATE_ANALYSIS_TABLE_DATA_URL =
  'https://airbtics-resource.s3.us-east-2.amazonaws.com/ca_real_estate_investability-5_years_trend.csv';

export const AU_AIRBNB_STATISTICS_DATA_URL =
  'https://airbtics-resource.s3.us-east-2.amazonaws.com/au_markets_top_city.csv';
export const AU_REAL_ESTATE_ANALYSIS_TABLE_DATA_URL =
  'https://airbtics-resource.s3.us-east-2.amazonaws.com/au_real_estate_investability-5_years_trend.csv';

export const countryWiseAirbticsProTableLinks = {
  US: {
    statistics_data: US_AIRBNB_STATISTICS_DATA_URL,
    real_estate_analysis_data: US_REAL_ESTATE_ANALYSIS_TABLE_DATA_URL,
  },
  UK: {
    statistics_data: UK_AIRBNB_STATISTICS_DATA_URL,
    real_estate_analysis_data: UK_REAL_ESTATE_ANALYSIS_TABLE_DATA_URL,
  },
  CA: {
    statistics_data: CA_AIRBNB_STATISTICS_DATA_URL,
    real_estate_analysis_data: CA_REAL_ESTATE_ANALYSIS_TABLE_DATA_URL,
  },
  AU: {
    statistics_data: AU_AIRBNB_STATISTICS_DATA_URL,
    real_estate_analysis_data: AU_REAL_ESTATE_ANALYSIS_TABLE_DATA_URL,
  },
};

export const countryWiseAirbticsProImgLinkObj = {
  US: AirbticsProImageUS,
  UK: AirbticsProImageUK,
  CA: AirbticsProImageCA,
  AU: AirbticsProImageAU,
};

export const airbticsProCountries = { USA: 'US', CANADA: 'CA', AUSTRALIA: 'AU', UK: 'UK' };

export const countryWiseAirbticsProPaymentLinkObj = {
  US: AIRBTICS_PRO_PAYMENT_LINK_US,
  UK: AIRBTICS_PRO_PAYMENT_LINK_UK,
  CA: AIRBTICS_PRO_PAYMENT_LINK_CA,
  AU: AIRBTICS_PRO_PAYMENT_LINK_AU,
};

export const shortMonthNames = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const airbnbManageYourSpaceUrls = [
  'https://www.airbnb.ae/manage-your-space/',
  'https://www.airbnb.al/manage-your-space/',
  'https://www.airbnb.am/manage-your-space/',
  'https://www.airbnb.at/manage-your-space/',
  'https://www.airbnb.az/manage-your-space/',
  'https://www.airbnb.ba/manage-your-space/',
  'https://www.airbnb.be/manage-your-space/',
  'https://www.airbnb.ca/manage-your-space/',
  'https://www.airbnb.cat/manage-your-space/',
  'https://www.airbnb.ch/manage-your-space/',
  'https://www.airbnb.co.in/manage-your-space/',
  'https://www.airbnb.cl/manage-your-space/',
  'https://www.airbnb.cn/manage-your-space/',
  'https://www.airbnb.co.cr/manage-your-space/',
  'https://www.airbnb.co.id/manage-your-space/',
  'https://www.airbnb.co.il/manage-your-space/',
  'https://www.airbnb.co.kr/manage-your-space/',
  'https://www.airbnb.com/manage-your-space/',
  'https://www.airbnb.com.ar/manage-your-space/',
  'https://www.airbnb.com.au/manage-your-space/',
  'https://www.airbnb.com.bo/manage-your-space/',
  'https://www.airbnb.com.br/manage-your-space/',
  'https://www.airbnb.com.bz/manage-your-space/',
  'https://www.airbnb.com.co/manage-your-space/',
  'https://www.airbnb.com.ec/manage-your-space/',
  'https://www.airbnb.com.ee/manage-your-space/',
  'https://www.airbnb.com.gt/manage-your-space/',
  'https://www.airbnb.com.hk/manage-your-space/',
  'https://www.airbnb.com.hn/manage-your-space/',
  'https://www.airbnb.com.hr/manage-your-space/',
  'https://www.airbnb.com.kh/manage-your-space/',
  'https://www.airbnb.com.mt/manage-your-space/',
  'https://www.airbnb.com.my/manage-your-space/',
  'https://www.airbnb.com.ni/manage-your-space/',
  'https://www.airbnb.com.pa/manage-your-space/',
  'https://www.airbnb.com.pe/manage-your-space/',
  'https://www.airbnb.com.ph/manage-your-space/',
  'https://www.airbnb.com.py/manage-your-space/',
  'https://www.airbnb.com.ro/manage-your-space/',
  'https://www.airbnb.com.sg/manage-your-space/',
  'https://www.airbnb.com.sv/manage-your-space/',
  'https://www.airbnb.com.tr/manage-your-space/',
  'https://www.airbnb.com.tw/manage-your-space/',
  'https://www.airbnb.com.ua/manage-your-space/',
  'https://www.airbnb.com.vn/manage-your-space/',
  'https://www.airbnb.co.nz/manage-your-space/',
  'https://www.airbnb.co.uk/manage-your-space/',
  'https://www.airbnb.co.ve/manage-your-space/',
  'https://www.airbnb.co.za/manage-your-space/',
  'https://www.airbnb.cz/manage-your-space/',
  'https://www.airbnb.de/manage-your-space/',
  'https://www.airbnb.dk/manage-your-space/',
  'https://www.airbnb.es/manage-your-space/',
  'https://www.airbnb.fi/manage-your-space/',
  'https://www.airbnb.fr/manage-your-space/',
  'https://www.airbnb.gr/manage-your-space/',
  'https://www.airbnb.hu/manage-your-space/',
  'https://www.airbnb.ie/manage-your-space/',
  'https://www.airbnb.is/manage-your-space/',
  'https://www.airbnb.it/manage-your-space/',
  'https://www.airbnb.jp/manage-your-space/',
  'https://www.airbnb.la/manage-your-space/',
  'https://www.airbnb.lt/manage-your-space/',
  'https://www.airbnb.lu/manage-your-space/',
  'https://www.airbnb.lv/manage-your-space/',
  'https://www.airbnb.me/manage-your-space/',
  'https://www.airbnb.mx/manage-your-space/',
  'https://www.airbnb.nl/manage-your-space/',
  'https://www.airbnb.no/manage-your-space/',
  'https://www.airbnb.pl/manage-your-space/',
  'https://www.airbnb.pt/manage-your-space/',
  'https://www.airbnb.rs/manage-your-space/',
  'https://www.airbnb.ru/manage-your-space/',
  'https://www.airbnb.se/manage-your-space/',
  'https://www.airbnb.si/manage-your-space/',
];

export const WORDPRESS_TO_DISCOVERY_KEY = 'wpy4Zmpg4eCm5WcpA0wp';

export const amenitiesObject = {
  beachfront: 'Beachfront',
  amazing_views: 'Amazing Views',
  pool: 'Pool',
  hot_tub: 'Hot Tub',
  parking: 'Parking',
  pets: 'Pet Friendly',
  ac: 'AC',
  heating: 'Heating',
  breakfast: 'Breakfast',
  dryer: 'Dryer',
  washer: 'Washer',
  gym: 'Gym',
  kitchen: 'Kitchen',
  tv: 'TV',
  wifi: 'WiFi',
  bbq_grill: 'BBQ Grill',
  fireplace: 'Fireplace',
};

export const mainKpiOccupancyDummyData = [
  {
    '2021': {
      occupancy_rate25: 34,
      occupancy_rate50: 60,
      occupancy_rate75: 92,
      occupancy_rate90: 100,
    },
    '2022': {
      occupancy_rate25: 28,
      occupancy_rate50: 55,
      occupancy_rate75: 87,
      occupancy_rate90: 100,
    },
    month: 'Nov',
    LTMData: {
      occupancy_rate25: 28,
      occupancy_rate50: 55,
      occupancy_rate75: 87,
      occupancy_rate90: 100,
    },
    precedingData: {
      occupancy_rate25: 34,
      occupancy_rate50: 60,
      occupancy_rate75: 92,
      occupancy_rate90: 100,
    },
    latestYear: 2022,
    previousYear: 2021,
    monthYear: 'Nov,22',
  },
  {
    '2021': {
      occupancy_rate25: 31,
      occupancy_rate50: 60,
      occupancy_rate75: 89,
      occupancy_rate90: 100,
    },
    '2022': {
      occupancy_rate25: 42,
      occupancy_rate50: 65,
      occupancy_rate75: 92,
      occupancy_rate90: 100,
    },
    month: 'Dec',
    LTMData: {
      occupancy_rate25: 42,
      occupancy_rate50: 65,
      occupancy_rate75: 92,
      occupancy_rate90: 100,
    },
    precedingData: {
      occupancy_rate25: 31,
      occupancy_rate50: 60,
      occupancy_rate75: 89,
      occupancy_rate90: 100,
    },
    latestYear: 2022,
    previousYear: 2021,
    monthYear: 'Dec,22',
  },
  {
    '2021': {
      occupancy_rate25: null,
      occupancy_rate50: 60,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    '2022': {
      occupancy_rate25: 28,
      occupancy_rate50: 55,
      occupancy_rate75: 86,
      occupancy_rate90: 100,
    },
    '2023': {
      occupancy_rate25: 20,
      occupancy_rate50: 46,
      occupancy_rate75: 80,
      occupancy_rate90: 100,
    },
    month: 'Jan',
    LTMData: {
      occupancy_rate25: 20,
      occupancy_rate50: 46,
      occupancy_rate75: 80,
      occupancy_rate90: 100,
    },
    precedingData: {
      occupancy_rate25: 28,
      occupancy_rate50: 55,
      occupancy_rate75: 86,
      occupancy_rate90: 100,
    },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Jan,23',
  },
  {
    '2021': {
      occupancy_rate25: 22,
      occupancy_rate50: 56,
      occupancy_rate75: 87,
      occupancy_rate90: 100,
    },
    '2022': {
      occupancy_rate25: 37,
      occupancy_rate50: 65,
      occupancy_rate75: 93,
      occupancy_rate90: 100,
    },
    '2023': {
      occupancy_rate25: 34,
      occupancy_rate50: 60,
      occupancy_rate75: 84,
      occupancy_rate90: 100,
    },
    month: 'Feb',
    LTMData: {
      occupancy_rate25: 34,
      occupancy_rate50: 60,
      occupancy_rate75: 84,
      occupancy_rate90: 100,
    },
    precedingData: {
      occupancy_rate25: 37,
      occupancy_rate50: 65,
      occupancy_rate75: 93,
      occupancy_rate90: 100,
    },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Feb,23',
  },
  {
    '2021': {
      occupancy_rate25: 19,
      occupancy_rate50: 51,
      occupancy_rate75: 89,
      occupancy_rate90: 100,
    },
    '2022': {
      occupancy_rate25: 29,
      occupancy_rate50: 60,
      occupancy_rate75: 92,
      occupancy_rate90: 100,
    },
    '2023': {
      occupancy_rate25: 30,
      occupancy_rate50: 56,
      occupancy_rate75: 84,
      occupancy_rate90: 100,
    },
    month: 'Mar',
    LTMData: {
      occupancy_rate25: 30,
      occupancy_rate50: 56,
      occupancy_rate75: 84,
      occupancy_rate90: 100,
    },
    precedingData: {
      occupancy_rate25: 29,
      occupancy_rate50: 60,
      occupancy_rate75: 92,
      occupancy_rate90: 100,
    },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Mar,23',
  },
  {
    '2021': {
      occupancy_rate25: 40,
      occupancy_rate50: 72,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    '2022': {
      occupancy_rate25: 56,
      occupancy_rate50: 80,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    '2023': {
      occupancy_rate25: 48,
      occupancy_rate50: 74,
      occupancy_rate75: 97,
      occupancy_rate90: 100,
    },
    month: 'Apr',
    LTMData: {
      occupancy_rate25: 48,
      occupancy_rate50: 74,
      occupancy_rate75: 97,
      occupancy_rate90: 100,
    },
    precedingData: {
      occupancy_rate25: 56,
      occupancy_rate50: 80,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Apr,23',
  },
  {
    '2021': {
      occupancy_rate25: 27,
      occupancy_rate50: 55,
      occupancy_rate75: 86,
      occupancy_rate90: 100,
    },
    '2022': {
      occupancy_rate25: 48,
      occupancy_rate50: 74,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    '2023': {
      occupancy_rate25: 40,
      occupancy_rate50: 65,
      occupancy_rate75: 91,
      occupancy_rate90: 100,
    },
    month: 'May',
    LTMData: {
      occupancy_rate25: 40,
      occupancy_rate50: 65,
      occupancy_rate75: 91,
      occupancy_rate90: 100,
    },
    precedingData: {
      occupancy_rate25: 48,
      occupancy_rate50: 74,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'May,23',
  },
  {
    '2021': {
      occupancy_rate25: 50,
      occupancy_rate50: 80,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    '2022': {
      occupancy_rate25: 51,
      occupancy_rate50: 80,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    '2023': {
      occupancy_rate25: 49,
      occupancy_rate50: 76,
      occupancy_rate75: 99,
      occupancy_rate90: 100,
    },
    month: 'Jun',
    LTMData: {
      occupancy_rate25: 49,
      occupancy_rate50: 76,
      occupancy_rate75: 99,
      occupancy_rate90: 100,
    },
    precedingData: {
      occupancy_rate25: 51,
      occupancy_rate50: 80,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Jun,23',
  },
  {
    '2021': {
      occupancy_rate25: 81,
      occupancy_rate50: 100,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    '2022': {
      occupancy_rate25: 83,
      occupancy_rate50: 100,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    '2023': {
      occupancy_rate25: 68,
      occupancy_rate50: 92,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    month: 'Jul',
    LTMData: {
      occupancy_rate25: 68,
      occupancy_rate50: 92,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    precedingData: {
      occupancy_rate25: 83,
      occupancy_rate50: 100,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Jul,23',
  },
  {
    '2021': {
      occupancy_rate25: 85,
      occupancy_rate50: 100,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    '2022': {
      occupancy_rate25: 60,
      occupancy_rate50: 87,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    '2023': {
      occupancy_rate25: 60,
      occupancy_rate50: 86,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    month: 'Aug',
    LTMData: {
      occupancy_rate25: 60,
      occupancy_rate50: 86,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    precedingData: {
      occupancy_rate25: 60,
      occupancy_rate50: 87,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Aug,23',
  },
  {
    '2021': {
      occupancy_rate25: 60,
      occupancy_rate50: 90,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    '2022': {
      occupancy_rate25: 51,
      occupancy_rate50: 80,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    '2023': {
      occupancy_rate25: 56,
      occupancy_rate50: 80,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    month: 'Sep',
    LTMData: {
      occupancy_rate25: 56,
      occupancy_rate50: 80,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    precedingData: {
      occupancy_rate25: 51,
      occupancy_rate50: 80,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Sep,23',
  },
  {
    '2021': {
      occupancy_rate25: 60,
      occupancy_rate50: 85,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    '2022': {
      occupancy_rate25: 49,
      occupancy_rate50: 74,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    '2023': {
      occupancy_rate25: 31,
      occupancy_rate50: 58,
      occupancy_rate75: 85,
      occupancy_rate90: 100,
    },
    month: 'Oct',
    LTMData: {
      occupancy_rate25: 31,
      occupancy_rate50: 58,
      occupancy_rate75: 85,
      occupancy_rate90: 100,
    },
    precedingData: {
      occupancy_rate25: 49,
      occupancy_rate50: 74,
      occupancy_rate75: 100,
      occupancy_rate90: 100,
    },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Oct,23',
  },
];

export const mainKpiRevenueDummyData = [
  {
    '2021': { revenue25: 787, revenue50: 2102, revenue75: 5247, revenue90: 10170 },
    '2022': { revenue25: 594, revenue50: 1676, revenue75: 4116, revenue90: 8106 },
    month: 'Nov',
    LTMData: { revenue25: 594, revenue50: 1676, revenue75: 4116, revenue90: 8106 },
    precedingData: { revenue25: 787, revenue50: 2102, revenue75: 5247, revenue90: 10170 },
    latestYear: 2022,
    previousYear: 2021,
    monthYear: 'Nov,22',
  },
  {
    '2021': { revenue25: 731, revenue50: 2105, revenue75: 5210, revenue90: 10203 },
    '2022': { revenue25: 921, revenue50: 2132, revenue75: 4753, revenue90: 8980 },
    month: 'Dec',
    LTMData: { revenue25: 921, revenue50: 2132, revenue75: 4753, revenue90: 8980 },
    precedingData: { revenue25: 731, revenue50: 2105, revenue75: 5210, revenue90: 10203 },
    latestYear: 2022,
    previousYear: 2021,
    monthYear: 'Dec,22',
  },
  {
    '2021': { revenue25: 0, revenue50: 1576, revenue75: 3626, revenue90: 4939 },
    '2022': { revenue25: 634, revenue50: 1850, revenue75: 4803, revenue90: 10050 },
    '2023': { revenue25: 404, revenue50: 1352, revenue75: 3683, revenue90: 7562 },
    month: 'Jan',
    LTMData: { revenue25: 404, revenue50: 1352, revenue75: 3683, revenue90: 7562 },
    precedingData: { revenue25: 634, revenue50: 1850, revenue75: 4803, revenue90: 10050 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Jan,23',
  },
  {
    '2021': { revenue25: 413, revenue50: 1498, revenue75: 3506, revenue90: 6621 },
    '2022': { revenue25: 874, revenue50: 2282, revenue75: 5239, revenue90: 10101 },
    '2023': { revenue25: 729, revenue50: 1836, revenue75: 3951, revenue90: 7745 },
    month: 'Feb',
    LTMData: { revenue25: 729, revenue50: 1836, revenue75: 3951, revenue90: 7745 },
    precedingData: { revenue25: 874, revenue50: 2282, revenue75: 5239, revenue90: 10101 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Feb,23',
  },
  {
    '2021': { revenue25: 401, revenue50: 1536, revenue75: 4135, revenue90: 7324 },
    '2022': { revenue25: 692, revenue50: 2062, revenue75: 5107, revenue90: 9907 },
    '2023': { revenue25: 651, revenue50: 1808, revenue75: 4070, revenue90: 8227 },
    month: 'Mar',
    LTMData: { revenue25: 651, revenue50: 1808, revenue75: 4070, revenue90: 8227 },
    precedingData: { revenue25: 692, revenue50: 2062, revenue75: 5107, revenue90: 9907 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Mar,23',
  },
  {
    '2021': { revenue25: 925, revenue50: 2576, revenue75: 5315, revenue90: 8448 },
    '2022': { revenue25: 1416, revenue50: 3147, revenue75: 6228, revenue90: 10314 },
    '2023': { revenue25: 1145, revenue50: 2657, revenue75: 5493, revenue90: 9084 },
    month: 'Apr',
    LTMData: { revenue25: 1145, revenue50: 2657, revenue75: 5493, revenue90: 9084 },
    precedingData: { revenue25: 1416, revenue50: 3147, revenue75: 6228, revenue90: 10314 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Apr,23',
  },
  {
    '2021': { revenue25: 644, revenue50: 2035, revenue75: 5112, revenue90: 10200 },
    '2022': { revenue25: 1174, revenue50: 2791, revenue75: 5992, revenue90: 10103 },
    '2023': { revenue25: 1012, revenue50: 2412, revenue75: 5398, revenue90: 9298 },
    month: 'May',
    LTMData: { revenue25: 1012, revenue50: 2412, revenue75: 5398, revenue90: 9298 },
    precedingData: { revenue25: 1174, revenue50: 2791, revenue75: 5992, revenue90: 10103 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'May,23',
  },
  {
    '2021': { revenue25: 1277, revenue50: 3167, revenue75: 6324, revenue90: 11122 },
    '2022': { revenue25: 1278, revenue50: 3138, revenue75: 6284, revenue90: 10601 },
    '2023': { revenue25: 1240, revenue50: 2820, revenue75: 5733, revenue90: 9347 },
    month: 'Jun',
    LTMData: { revenue25: 1240, revenue50: 2820, revenue75: 5733, revenue90: 9347 },
    precedingData: { revenue25: 1278, revenue50: 3138, revenue75: 6284, revenue90: 10601 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Jun,23',
  },
  {
    '2021': { revenue25: 2049, revenue50: 4203, revenue75: 7071, revenue90: 12488 },
    '2022': { revenue25: 2160, revenue50: 4098, revenue75: 6593, revenue90: 10788 },
    '2023': { revenue25: 1884, revenue50: 3801, revenue75: 6476, revenue90: 10220 },
    month: 'Jul',
    LTMData: { revenue25: 1884, revenue50: 3801, revenue75: 6476, revenue90: 10220 },
    precedingData: { revenue25: 2160, revenue50: 4098, revenue75: 6593, revenue90: 10788 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Jul,23',
  },
  {
    '2021': { revenue25: 2233, revenue50: 4488, revenue75: 7622, revenue90: 12769 },
    '2022': { revenue25: 1561, revenue50: 3593, revenue75: 6600, revenue90: 10464 },
    '2023': { revenue25: 1662, revenue50: 3585, revenue75: 6236, revenue90: 9701 },
    month: 'Aug',
    LTMData: { revenue25: 1662, revenue50: 3585, revenue75: 6236, revenue90: 9701 },
    precedingData: { revenue25: 1561, revenue50: 3593, revenue75: 6600, revenue90: 10464 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Aug,23',
  },
  {
    '2021': { revenue25: 1547, revenue50: 3693, revenue75: 6511, revenue90: 10968 },
    '2022': { revenue25: 1179, revenue50: 2816, revenue75: 5538, revenue90: 9502 },
    '2023': { revenue25: 1403, revenue50: 2910, revenue75: 5374, revenue90: 8297 },
    month: 'Sep',
    LTMData: { revenue25: 1403, revenue50: 2910, revenue75: 5374, revenue90: 8297 },
    precedingData: { revenue25: 1179, revenue50: 2816, revenue75: 5538, revenue90: 9502 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Sep,23',
  },
  {
    '2021': { revenue25: 1503, revenue50: 3272, revenue75: 6174, revenue90: 10746 },
    '2022': { revenue25: 1045, revenue50: 2398, revenue75: 5079, revenue90: 9057 },
    '2023': { revenue25: 717, revenue50: 1928, revenue75: 4301, revenue90: 7946 },
    month: 'Oct',
    LTMData: { revenue25: 717, revenue50: 1928, revenue75: 4301, revenue90: 7946 },
    precedingData: { revenue25: 1045, revenue50: 2398, revenue75: 5079, revenue90: 9057 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Oct,23',
  },
];

export const mainKpiListingDummydata = [
  {
    '2021': { active_listings_count: 1026 },
    '2022': { active_listings_count: 1269 },
    month: 'Nov',
    LTMData: { active_listings_count: 1269 },
    precedingData: { active_listings_count: 1026 },
    latestYear: 2022,
    previousYear: 2021,
    monthYear: 'Nov,22',
  },
  {
    '2021': { active_listings_count: 990 },
    '2022': { active_listings_count: 1275 },
    month: 'Dec',
    LTMData: { active_listings_count: 1275 },
    precedingData: { active_listings_count: 990 },
    latestYear: 2022,
    previousYear: 2021,
    monthYear: 'Dec,22',
  },
  {
    '2021': { active_listings_count: 271 },
    '2022': { active_listings_count: 1093 },
    '2023': { active_listings_count: 1368 },
    month: 'Jan',
    LTMData: { active_listings_count: 1368 },
    precedingData: { active_listings_count: 1093 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Jan,23',
  },
  {
    '2021': { active_listings_count: 433 },
    '2022': { active_listings_count: 1133 },
    '2023': { active_listings_count: 1611 },
    month: 'Feb',
    LTMData: { active_listings_count: 1611 },
    precedingData: { active_listings_count: 1133 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Feb,23',
  },
  {
    '2021': { active_listings_count: 443 },
    '2022': { active_listings_count: 1245 },
    '2023': { active_listings_count: 1826 },
    month: 'Mar',
    LTMData: { active_listings_count: 1826 },
    precedingData: { active_listings_count: 1245 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Mar,23',
  },
  {
    '2021': { active_listings_count: 690 },
    '2022': { active_listings_count: 1383 },
    '2023': { active_listings_count: 1940 },
    month: 'Apr',
    LTMData: { active_listings_count: 1940 },
    precedingData: { active_listings_count: 1383 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Apr,23',
  },
  {
    '2021': { active_listings_count: 798 },
    '2022': { active_listings_count: 1439 },
    '2023': { active_listings_count: 1966 },
    month: 'May',
    LTMData: { active_listings_count: 1966 },
    precedingData: { active_listings_count: 1439 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'May,23',
  },
  {
    '2021': { active_listings_count: 832 },
    '2022': { active_listings_count: 1463 },
    '2023': { active_listings_count: 2351 },
    month: 'Jun',
    LTMData: { active_listings_count: 2351 },
    precedingData: { active_listings_count: 1463 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Jun,23',
  },
  {
    '2021': { active_listings_count: 954 },
    '2022': { active_listings_count: 1520 },
    '2023': { active_listings_count: 2494 },
    month: 'Jul',
    LTMData: { active_listings_count: 2494 },
    precedingData: { active_listings_count: 1520 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Jul,23',
  },
  {
    '2021': { active_listings_count: 973 },
    '2022': { active_listings_count: 1545 },
    '2023': { active_listings_count: 3191 },
    month: 'Aug',
    LTMData: { active_listings_count: 3191 },
    precedingData: { active_listings_count: 1545 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Aug,23',
  },
  {
    '2021': { active_listings_count: 1114 },
    '2022': { active_listings_count: 1448 },
    '2023': { active_listings_count: 2720 },
    month: 'Sep',
    LTMData: { active_listings_count: 2720 },
    precedingData: { active_listings_count: 1448 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Sep,23',
  },
  {
    '2021': { active_listings_count: 1104 },
    '2022': { active_listings_count: 1351 },
    '2023': { active_listings_count: 2359 },
    month: 'Oct',
    LTMData: { active_listings_count: 2359 },
    precedingData: { active_listings_count: 1351 },
    latestYear: 2023,
    previousYear: 2022,
    monthYear: 'Oct,23',
  },
];

// z indeces

export const APP_BAR_Z_INDEX = 1100;
export const SIDE_BAR_Z_INDEX = APP_BAR_Z_INDEX + 1;
export const KPI_NAV_BAR_Z_INDEX = APP_BAR_Z_INDEX - 1;
export const FILTER_FLOAT_BUTTON_Z_INDEX = KPI_NAV_BAR_Z_INDEX - 1;
export const NEIGHBOURHOOD_TOOLTIP_Z_INDEX = 999997;

export const NAV_BAR_DYNAMIC_SVG_SIMPLE = 'TE6zqUJQPCPH1_-_nRgplwkp9A7SjUbq0Gcq2VDndKA=';

//local storage key
export const DATA_VERIFICATION_ATTEMPT_TRACKER_LS_KEY = 'data_verification_attempt_tracker';

export const MAP_VIEW_TOOLTIP_MAPPING = {
  'Occupancy (Median)': 0,
  Revenue: 1,
  'Nightly Rate (Median)': 2,
  Listings: 3,
};

export const OVERVIEW_DASHBOARD_FILTER_DEMO_DATA = {
  propertyType: {
    entire_home: {
      occupancyRate: 60,
      adr: 45,
      revenue: 47507,
    },
    private_room: {
      occupancyRate: 70,
      adr: 95,
      revenue: 18189,
    },
    condo: {
      occupancyRate: 80,
      adr: 45,
      revenue: 41373,
    },
    hotel_room: {
      occupancyRate: 60,
      adr: 95,
      revenue: 23367,
    },
    shared_room: {
      occupancyRate: 70,
      adr: 45,
      revenue: 9343.5,
    },
  },
  propertySize: {
    studio: {
      occupancyRate: 80,
      adr: 45,
      revenue: 30000,
    },
    '1': {
      occupancyRate: 60,
      adr: 95,
      revenue: 45000,
    },
    '2': {
      occupancyRate: 70,
      adr: 45,
      revenue: 30000,
    },
    '3': {
      occupancyRate: 80,
      adr: 95,
      revenue: 45000,
    },
    '4': {
      occupancyRate: 60,
      adr: 45,
      revenue: 30000,
    },
    '5': {
      occupancyRate: 70,
      adr: 95,
      revenue: 45000,
    },
    '6+': {
      occupancyRate: 60,
      adr: 45,
      revenue: 30000,
    },
  },
  amenity: {
    pool: {
      revPanChange: 100,
    },
    parking: {
      revPanChange: 0,
    },
    hot_tub: {
      revPanChange: 0,
    },
    gym: {
      revPanChange: 0,
    },
    dryer: {
      revPanChange: 10,
    },
    washer: {
      revPanChange: 14,
    },
    kitchen: {
      revPanChange: 42,
    },
    ac: {
      revPanChange: 0,
    },
    heating: {
      revPanChange: 9,
    },
    wifi: {
      revPanChange: 23,
    },
    tv: {
      revPanChange: 11,
    },
    bbq_grill: {
      revPanChange: 0,
    },
    fireplace: {
      revPanChange: 11,
    },
    breakfast: {
      revPanChange: 0,
    },
  },
  bathroomNumber: {
    '0': {
      occupancyRate: 60,
    },
    '1': {
      occupancyRate: 70,
    },
    '2': {
      occupancyRate: 80,
    },
    '3': {
      occupancyRate: 60,
    },
    '4': {
      occupancyRate: 70,
    },
    '5': {
      occupancyRate: 80,
    },
    '6+': {
      occupancyRate: 60,
    },
  },
  adrRange: {
    '11-93': {
      occupancyRate: 60,
    },
    '93-134': {
      occupancyRate: 70,
    },
    '134-177': {
      occupancyRate: 80,
    },
    '177-251': {
      occupancyRate: 60,
    },
    '251-1934': {
      occupancyRate: 70,
    },
  },
  ratingRange: {
    '0-4': {
      occupancyRate: 60,
    },
    '4-4.3': {
      occupancyRate: 70,
    },
    '4.3-4.6': {
      occupancyRate: 80,
    },
    '4.6-4.8': {
      occupancyRate: 60,
    },
    '4.8-5.1': {
      occupancyRate: 70,
    },
  },
  minNightRange: {
    '1-6': {
      occupancyRate: 60,
    },
    '7-29': {
      occupancyRate: 70,
    },
    '30-999': {
      occupancyRate: 80,
    },
  },
  capacity: {
    '1': {
      supply: 60,
    },
    '2': {
      supply: 70,
    },
    '3': {
      supply: 80,
    },
    '4': {
      supply: 60,
    },
    '5': {
      supply: 70,
    },
    '6': {
      supply: 80,
    },
    '7': {
      supply: 60,
    },
    '8': {
      supply: 70,
    },
    '9': {
      supply: 80,
    },
    '10': {
      supply: 60,
    },
    '11': {
      supply: 70,
    },
    '12': {
      supply: 80,
    },
    '13': {
      supply: 60,
    },
    '14': {
      supply: 70,
    },
    '15': {
      supply: 80,
    },
    '16+': {
      supply: 60,
    },
  },
  daysAvailable: {
    '1-90': {
      supply: 60,
    },
    '91-180': {
      supply: 70,
    },
    '181-270': {
      supply: 80,
    },
    '271-366': {
      supply: 60,
    },
  },
  listingsPerHost: {
    '1': {
      occupancyRate: 60,
    },
    '2-5': {
      occupancyRate: 70,
    },
    '6-20': {
      occupancyRate: 80,
    },
    '21+': {
      occupancyRate: 60,
    },
  },
  propertyTypeMetricsDistributionObject: {
    entire_home: {
      occupancyRate: {
        '0 - 10': 2,
        '10 - 20': 44,
        '20 - 30': 77,
        '30 - 40': 155,
        '40 - 50': 182,
        '50 - 60': 269,
        '60 - 70': 279,
        '70 - 80': 300,
        '80 - 90': 274,
        '90 - 100': 364,
      },
      adr: {
        '49 - 116': 316,
        '116 - 276': 1095,
        '276 - 655': 426,
        '655 - 1553': 94,
        '1553 - 3685': 14,
      },
      revenue: {
        '2922 - 9959': 19,
        '9959 - 33941': 529,
        '33941 - 115679': 1193,
        '115679 - 394259': 189,
        '394259 - 1343713': 15,
      },
    },
    private_room: {
      occupancyRate: {
        '0 - 10': 2,
        '10 - 20': 26,
        '20 - 30': 43,
        '30 - 40': 61,
        '40 - 50': 94,
        '50 - 60': 94,
        '60 - 70': 133,
        '70 - 80': 132,
        '80 - 90': 105,
        '90 - 100': 111,
      },
      adr: {
        '21 - 66': 284,
        '66 - 207': 474,
        '207 - 650': 39,
        '650 - 2041': 3,
        '2041 - 6407': 1,
      },
      revenue: {
        '1198 - 4892': 19,
        '4892 - 19976': 467,
        '19976 - 81568': 300,
        '81568 - 333075': 14,
        '333075 - 1360076': 0,
      },
    },
    condo: {
      occupancyRate: {
        '0 - 10': 0,
        '10 - 20': 7,
        '20 - 30': 19,
        '30 - 40': 31,
        '40 - 50': 44,
        '50 - 60': 74,
        '60 - 70': 84,
        '70 - 80': 96,
        '80 - 90': 81,
        '90 - 100': 104,
      },
      adr: {
        '60 - 102': 52,
        '102 - 174': 265,
        '174 - 296': 182,
        '296 - 503': 35,
        '503 - 856': 5,
      },
      revenue: {
        '7334 - 14305': 10,
        '14305 - 27902': 93,
        '27902 - 54424': 299,
        '54424 - 106154': 124,
        '106154 - 207055': 14,
      },
    },
    hotel_room: {
      occupancyRate: {
        '0 - 10': 0,
        '10 - 20': 0,
        '20 - 30': 2,
        '30 - 40': 0,
        '40 - 50': 0,
        '50 - 60': 2,
        '60 - 70': 0,
        '70 - 80': 1,
        '80 - 90': 3,
        '90 - 100': 2,
      },
      adr: {
        '72 - 88': 5,
        '88 - 107': 0,
        '107 - 130': 1,
        '130 - 158': 3,
        '158 - 192': 0,
      },
      revenue: {
        '13724 - 18285': 2,
        '18285 - 24363': 1,
        '24363 - 32460': 4,
        '32460 - 43249': 1,
        '43249 - 57623': 1,
      },
    },
    shared_room: {
      occupancyRate: {
        '0 - 10': 0,
        '10 - 20': 1,
        '20 - 30': 1,
        '30 - 40': 1,
        '40 - 50': 1,
        '50 - 60': 2,
        '60 - 70': 2,
        '70 - 80': 1,
        '80 - 90': 0,
        '90 - 100': 0,
      },
      adr: {
        '28 - 39': 7,
        '39 - 55': 1,
        '55 - 77': 0,
        '77 - 108': 0,
        '108 - 152': 0,
      },
      revenue: {
        '1228 - 2086': 1,
        '2086 - 3544': 0,
        '3544 - 6021': 2,
        '6021 - 10229': 5,
        '10229 - 17377': 1,
      },
    },
  },
};

export const DEMO_DASHBOARD_FILTER_GRAPH_TOOLTIP_LTM_DATA = {
  occupancyRate: [
    { date: '2024-01', metric: 63 },
    { date: '2024-02', metric: 72 },
    { date: '2024-03', metric: 68 },
    { date: '2024-04', metric: 75 },
    { date: '2024-05', metric: 65 },
    { date: '2024-06', metric: 70 },
    { date: '2024-07', metric: 78 },
    { date: '2024-08', metric: 68 },
    { date: '2024-09', metric: 73 },
    { date: '2024-10', metric: 77 },
    { date: '2024-11', metric: 63 },
    { date: '2024-12', metric: 80 },
  ],
  adr: [
    { date: '2024-01', metric: 80 },
    { date: '2024-02', metric: 85 },
    { date: '2024-03', metric: 78 },
    { date: '2024-04', metric: 92 },
    { date: '2024-05', metric: 88 },
    { date: '2024-06', metric: 82 },
    { date: '2024-07', metric: 96 },
    { date: '2024-08', metric: 87 },
    { date: '2024-09', metric: 81 },
    { date: '2024-10', metric: 94 },
    { date: '2024-11', metric: 76 },
    { date: '2024-12', metric: 89 },
  ],
  revenue: [
    { date: '2024-01', metric: 5600 },
    { date: '2024-02', metric: 6250 },
    { date: '2024-03', metric: 7200 },
    { date: '2024-04', metric: 8900 },
    { date: '2024-05', metric: 7400 },
    { date: '2024-06', metric: 8100 },
    { date: '2024-07', metric: 9500 },
    { date: '2024-08', metric: 8300 },
    { date: '2024-09', metric: 7200 },
    { date: '2024-10', metric: 8800 },
    { date: '2024-11', metric: 6700 },
    { date: '2024-12', metric: 9500 },
  ],
};

export const US_CENTER = { lat: 39.8333333, lng: -98.585522 };
export const FIXED_CENTER_FOR_US_IN_MOBILE_VIEW = {
  lat: 14.372310047369794,
  lng: -98.58552199999998,
};

export const UK_CENTER = { lat: 54.1553497202996, lng: -2.89558470050636 };
export const FIXED_CENTER_FOR_UK_IN_MOBILE_VIEW = { lat: 54.1553497202996, lng: -2.89558470050636 };

export const AU_CENTER = { lat: -25.274398, lng: 133.775136 };
export const FIXED_CENTER_FOR_AU_IN_MOBILE_VIEW = { lat: -25.274398, lng: 133.775136 };

export const CA_CENTER = { lat: 56.130366, lng: -106.346771 };
export const FIXED_CENTER_FOR_CA_IN_MOBILE_VIEW = CA_CENTER;

export const MIN_ROI_FOR_MARKET_GRAD_IN_OVERVIEW = 2.0;
export const MAX_ROI_FOR_MARKET_GRAD_IN_OVERVIEW = 5.6;

export const userDisplayFriendlyCountryCode = {
  US: 'US',
  GB: 'UK',
  AU: 'Australia',
  CA: 'Canada',
};

export const AVAILABLE_COUNTRY = {
  US: 'United States',
  GB: 'United Kingdom',
  AU: 'Australia',
  CA: 'Canada',
};

export const ALL_COUNTRY = {
  US: 'United States',
  GB: 'United Kingdom',
  AU: 'Australia',
  CA: 'Canada',
  AF: 'Afghanistan',
  AL: 'Albania',
  DZ: 'Algeria',
  AS: 'American Samoa',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguilla',
  AQ: 'Antarctica',
  AG: 'Antigua and Barbuda',
  AR: 'Argentina',
  AM: 'Armenia',
  AW: 'Aruba',
  AT: 'Austria',
  AZ: 'Azerbaijan',
  BS: 'Bahamas',
  BH: 'Bahrain',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BY: 'Belarus',
  BE: 'Belgium',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermuda',
  BT: 'Bhutan',
  BO: 'Bolivia (Plurinational State of)',
  BQ: 'Bonaire, Sint Eustatius and Saba',
  BA: 'Bosnia and Herzegovina',
  BW: 'Botswana',
  BV: 'Bouvet Island',
  BR: 'Brazil',
  IO: 'British Indian Ocean Territory',
  BN: 'Brunei Darussalam',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  CV: 'Cabo Verde',
  KH: 'Cambodia',
  CM: 'Cameroon',
  KY: 'Cayman Islands',
  CF: 'Central African Republic',
  TD: 'Chad',
  CL: 'Chile',
  CN: 'China',
  CX: 'Christmas Island',
  CC: 'Cocos (Keeling) Islands',
  CO: 'Colombia',
  KM: 'Comoros',
  CD: 'Congo (the Democratic Republic of the)',
  CG: 'Congo',
  CK: 'Cook Islands',
  CR: 'Costa Rica',
  HR: 'Croatia',
  CU: 'Cuba',
  CW: 'Curaçao',
  CY: 'Cyprus',
  CZ: 'Czechia',
  CI: "Côte d'Ivoire",
  DK: 'Denmark',
  DJ: 'Djibouti',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  EC: 'Ecuador',
  EG: 'Egypt',
  SV: 'El Salvador',
  GQ: 'Equatorial Guinea',
  ER: 'Eritrea',
  EE: 'Estonia',
  SZ: 'Eswatini',
  ET: 'Ethiopia',
  FK: 'Falkland Islands [Malvinas]',
  FO: 'Faroe Islands',
  FJ: 'Fiji',
  FI: 'Finland',
  FR: 'France',
  GF: 'French Guiana',
  PF: 'French Polynesia',
  TF: 'French Southern Territories',
  GA: 'Gabon',
  GM: 'Gambia',
  GE: 'Georgia',
  DE: 'Germany',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Greece',
  GL: 'Greenland',
  GD: 'Grenada',
  GP: 'Guadeloupe',
  GU: 'Guam',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HT: 'Haiti',
  HM: 'Heard Island and McDonald Islands',
  VA: 'Holy See',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Hungary',
  IS: 'Iceland',
  IN: 'India',
  ID: 'Indonesia',
  IR: 'Iran (Islamic Republic of)',
  IQ: 'Iraq',
  IE: 'Ireland',
  IM: 'Isle of Man',
  IL: 'Israel',
  IT: 'Italy',
  JM: 'Jamaica',
  JP: 'Japan',
  JE: 'Jersey',
  JO: 'Jordan',
  KZ: 'Kazakhstan',
  KE: 'Kenya',
  KI: 'Kiribati',
  KP: "Korea (the Democratic People's Republic of)",
  KR: 'Korea (the Republic of)',
  KW: 'Kuwait',
  KG: 'Kyrgyzstan',
  LA: "Lao People's Democratic Republic",
  LV: 'Latvia',
  LB: 'Lebanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libya',
  LI: 'Liechtenstein',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MO: 'Macao',
  MG: 'Madagascar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Maldives',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Marshall Islands',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MU: 'Mauritius',
  YT: 'Mayotte',
  MX: 'Mexico',
  FM: 'Micronesia (Federated States of)',
  MD: 'Moldova (the Republic of)',
  MC: 'Monaco',
  MN: 'Mongolia',
  ME: 'Montenegro',
  MS: 'Montserrat',
  MA: 'Morocco',
  MZ: 'Mozambique',
  MM: 'Myanmar',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Netherlands',
  NC: 'New Caledonia',
  NZ: 'New Zealand',
  NI: 'Nicaragua',
  NE: 'Niger',
  NG: 'Nigeria',
  NU: 'Niue',
  NF: 'Norfolk Island',
  MP: 'Northern Mariana Islands',
  NO: 'Norway',
  OM: 'Oman',
  PK: 'Pakistan',
  PW: 'Palau',
  PS: 'Palestine',
  PA: 'Panama',
  PG: 'Papua New Guinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippines',
  PN: 'Pitcairn',
  PL: 'Poland',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Qatar',
  MK: 'Republic of North Macedonia',
  RO: 'Romania',
  RU: 'Russian Federation',
  RW: 'Rwanda',
  RE: 'Réunion',
  BL: 'Saint Barthélemy',
  SH: 'Saint Helena, Ascension and Tristan da Cunha',
  KN: 'Saint Kitts and Nevis',
  LC: 'Saint Lucia',
  MF: 'Saint Martin (French part)',
  PM: 'Saint Pierre and Miquelon',
  VC: 'Saint Vincent and the Grenadines',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'Sao Tome and Principe',
  SA: 'Saudi Arabia',
  SN: 'Senegal',
  RS: 'Serbia',
  SC: 'Seychelles',
  SL: 'Sierra Leone',
  SG: 'Singapore',
  SX: 'Sint Maarten (Dutch part)',
  SK: 'Slovakia',
  SI: 'Slovenia',
  SB: 'Solomon Islands',
  SO: 'Somalia',
  ZA: 'South Africa',
  GS: 'South Georgia and the South Sandwich Islands',
  SS: 'South Sudan',
  ES: 'Spain',
  LK: 'Sri Lanka',
  SD: 'Sudan',
  SR: 'Suriname',
  SJ: 'Svalbard and Jan Mayen',
  SE: 'Sweden',
  CH: 'Switzerland',
  SY: 'Syrian Arab Republic',
  TW: 'Taiwan',
  TJ: 'Tajikistan',
  TZ: 'Tanzania, United Republic of',
  TH: 'Thailand',
  TL: 'Timor-Leste',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trinidad and Tobago',
  TN: 'Tunisia',
  TR: 'Turkey',
  TM: 'Turkmenistan',
  TC: 'Turks and Caicos Islands',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ukraine',
  AE: 'United Arab Emirates',
  UM: 'United States Minor Outlying Islands',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VU: 'Vanuatu',
  VE: 'Venezuela (Bolivarian Republic of)',
  VN: 'Viet Nam',
  VG: 'Virgin Islands (British)',
  VI: 'Virgin Islands (U.S.)',
  WF: 'Wallis and Futuna',
  EH: 'Western Sahara',
  YE: 'Yemen',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
  AX: 'Åland Islands',
};

export const DISCOVERY_API_CACHE_DURATION = 1 * 60 * 60 * 1000;

export const BOOKING_STATUS_COLOR = {
  inactive: '#EFEFEF',
  available: '#71FF64',
  recentlyBooked: '#F95738',
  booked: '#86F8FF',
};

export const dummyData = [
  {
    name: 'Page A',
    uv: 4000,
    pv: 2400,
    amt: 2100,
  },
  {
    name: 'Page B',
    uv: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    name: 'Page C',
    uv: 2000,
    pv: 9800,
    amt: 2190,
  },
  {
    name: 'Page D',
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: 'Page E',
    uv: 1890,
    pv: 4800,
    amt: 2181,
  },
  {
    name: 'Page F',
    uv: 2390,
    pv: 3800,
    amt: 2200,
  },
  {
    name: 'Page G',
    uv: 3490,
    pv: 4300,
    amt: 2100,
  },
];
export const PRO_CTA = 'Upgrade to Pro Plan';
export const EXPERT_CTA = 'Upgrade to Expert Plan';
export const EXPERT_CTA_FOR_TAILOR_REGION = 'Upgrade to Expert Plan For Custom Market';
export const UNLOCK_CTA = 'Unlock';
export const SCALE_CTA = 'Upgrade to Scale Plan';
export const SUBSCRIPTION_MODAL_DATA_GRID_WIDTH_FOR_MOBILE = '880px';
export const SUBSCRIPTION_MODAL_DATA_GRID_WIDTH = '1230px';

export const SUBSCRIPTION_TABLE_ROWS = [
  {
    id: 0,
    feature: 'Null',
    starter: 'Insight Starter',
    pro: 'Insight Pro',
    expert: 'Analytics Expert',
    intelligence: 'Market Intelligence Scale',
  },
  {
    id: 1,
    feature: 'Historical Data',
    starter: 'year1',
    pro: 'year2',
    expert: 'year3',
    intelligence: 'through2021',
  },
  {
    id: 2,
    feature: 'Market Overview',
    starter: 'yes',
    pro: 'yes',
    expert: 'yes',
    intelligence: 'yes',
  },
  {
    id: 3,
    feature: 'Market Details',
    starter: 'no',
    pro: 'yes',
    expert: 'yes',
    intelligence: 'yes',
  },
  {
    id: 4,
    feature: 'Market Pacing Insights',
    starter: 'no',
    pro: 'comingSoon',
    expert: 'comingSoon',
    intelligence: 'comingSoon',
  },
  {
    id: 5,
    feature: 'Guest Insights⭐',
    starter: 'no',
    pro: 'yes',
    expert: 'yes',
    intelligence: 'yes',
  },
  {
    id: 6,
    feature: 'Host Insights',
    starter: 'no',
    pro: 'top10',
    expert: 'top10',
    intelligence: 'yes',
  },
  {
    id: 7,
    feature: 'Map Dynamic Data Updating ⭐',
    starter: 'no',
    pro: 'no',
    expert: 'yes',
    intelligence: 'yes',
  },
  {
    id: 8,
    feature: 'Calculate ROI (Estimator)',
    starter: 'limited',
    pro: 'yes',
    expert: 'yes',
    intelligence: 'yes',
  },
  {
    id: 9,
    feature: 'Individual Listing Overview',
    starter: 'no',
    pro: 'yes',
    expert: 'yes',
    intelligence: 'yes',
  },
  {
    id: 10,
    feature: 'Individual Listing Details',
    starter: 'no',
    pro: 'no',
    expert: 'no',
    intelligence: 'yes',
  },
  {
    id: 11,
    feature: 'Listing Filters',
    starter: 'no',
    pro: 'yes',
    expert: 'yes',
    intelligence: 'yes',
  },
  {
    id: 12,
    feature: 'Amenities & Performance Filters ⭐',
    starter: 'no',
    pro: 'no',
    expert: 'yes',
    intelligence: 'yes',
  },
  {
    id: 13,
    feature: 'Markets included',
    starter: 'allMarkets',
    pro: 'allMarkets',
    expert: 'allMarkets',
    intelligence: 'SpeakToSales',
  },
  {
    id: 14,
    feature: 'Custom Market ⭐',
    starter: 'no',
    pro: 'no',
    expert: 'yes',
    intelligence: 'yes',
  },
  {
    id: 15,
    feature: 'CSV data download',
    starter: 'no',
    pro: 'no',
    expert: 'no',
    intelligence: 'yes',
  },
  {
    id: 16,
    feature: 'Market Table View (Discovery)',
    starter: 'no',
    pro: 'no',
    expert: 'no',
    intelligence: 'yes',
  },
  {
    id: 17,
    feature: 'Markets Details Table View',
    starter: 'no',
    pro: 'no',
    expert: 'no',
    intelligence: 'yes',
  },
  {
    id: 18,
    feature: 'Property Manager View',
    starter: 'no',
    pro: 'no',
    expert: 'no',
    intelligence: 'yes',
  },
  {
    id: 19,
    feature: 'Listing Table View',
    starter: 'no',
    pro: 'no',
    expert: 'no',
    intelligence: 'yes',
  },
  {
    id: 20,
    feature: 'Money Back Gurantee',
    starter: 'yes',
    pro: 'yes',
    expert: 'yes',
    intelligence: 'no',
  },
];

export const SUBSCRIPTION_TABLE_ROWS_FOR_MOBILE_VIEW = [
  {
    id: 0,
    feature: 'Null',
    starter: 'Insight Starter',
    pro: 'Insight Pro',
    expert: 'Analytics Expert',
    intelligence: 'Market Intelligence Scale',
  },
  {
    id: 1,
    feature: '',
    starter: 'Historical Data',
    pro: '',
    expert: '',
    intelligence: '',
  },
  {
    id: 2,
    feature: 'Historical Data',
    starter: 'year1',
    pro: 'year2',
    expert: 'year3',
    intelligence: 'through2021',
  },
  {
    id: 3,
    starter: 'Market Overview',
    feature: '',
    pro: '',
    expert: '',
    intelligence: '',
  },
  {
    id: 4,
    feature: 'Market Overview',
    starter: 'yes',
    pro: 'yes',
    expert: 'yes',
    intelligence: 'yes',
  },
  {
    id: 5,
    starter: 'Market Details',
    feature: '',
    pro: '',
    expert: '',
    intelligence: '',
  },
  {
    id: 6,
    feature: 'Market Details',
    starter: 'no',
    pro: 'yes',
    expert: 'yes',
    intelligence: 'yes',
  },
  {
    id: 7,
    starter: 'Market Pacing Insights',
    feature: '',
    pro: '',
    expert: '',
    intelligence: '',
  },
  {
    id: 8,
    feature: 'Market Pacing Insights',
    starter: 'no',
    pro: 'comingSoon',
    expert: 'comingSoon',
    intelligence: 'comingSoon',
  },
  {
    id: 9,
    starter: 'Guest Insights⭐',
    feature: '',
    pro: '',
    expert: '',
    intelligence: '',
  },
  {
    id: 10,
    feature: 'Guest Insights⭐',
    starter: 'no',
    pro: 'yes',
    expert: 'yes',
    intelligence: 'yes',
  },
  {
    id: 11,
    starter: 'Host Insights',
    feature: '',
    pro: '',
    expert: '',
    intelligence: '',
  },
  {
    id: 12,
    feature: 'Host Insights',
    starter: 'no',
    pro: 'top10',
    expert: 'top10',
    intelligence: 'yes',
  },
  {
    id: 13,
    starter: 'Map Dynamic Data Updating ⭐',
    feature: '',
    pro: '',
    expert: '',
    intelligence: '',
  },
  {
    id: 14,
    feature: 'Map Dynamic Data Updating ⭐',
    starter: 'no',
    pro: 'no',
    expert: 'yes',
    intelligence: 'yes',
  },
  {
    id: 15,
    starter: 'Calculate ROI (Estimator)',
    feature: '',
    pro: '',
    expert: '',
    intelligence: '',
  },
  {
    id: 16,
    feature: 'Calculate ROI (Estimator)',
    starter: 'limited',
    pro: 'yes',
    expert: 'yes',
    intelligence: 'yes',
  },
  {
    id: 17,
    starter: 'Individual Listing Overview',
    feature: '',
    pro: '',
    expert: '',
    intelligence: '',
  },
  {
    id: 18,
    feature: 'Individual Listing Overview',
    starter: 'no',
    pro: 'yes',
    expert: 'yes',
    intelligence: 'yes',
  },
  {
    id: 19,
    starter: 'Individual Listing Details',
    feature: '',
    pro: '',
    expert: '',
    intelligence: '',
  },
  {
    id: 20,
    feature: 'Individual Listing Details',
    starter: 'no',
    pro: 'no',
    expert: 'no',
    intelligence: 'yes',
  },
  {
    id: 21,
    starter: 'Listing Filters',
    feature: '',
    pro: '',
    expert: '',
    intelligence: '',
  },
  {
    id: 22,
    feature: 'Listing Filters',
    starter: 'no',
    pro: 'yes',
    expert: 'yes',
    intelligence: 'yes',
  },
  {
    id: 23,
    starter: 'Amenities & Performance Filters ⭐',
    feature: '',
    pro: '',
    expert: '',
    intelligence: '',
  },
  {
    id: 24,
    feature: 'Amenities & Performance Filters ⭐',
    starter: 'no',
    pro: 'no',
    expert: 'yes',
    intelligence: 'yes',
  },
  {
    id: 25,
    starter: 'Markets included',
    feature: '',
    pro: '',
    expert: '',
    intelligence: '',
  },
  {
    id: 26,
    feature: 'Markets included',
    starter: 'allMarkets',
    pro: 'allMarkets',
    expert: 'allMarkets',
    intelligence: 'SpeakToSales',
  },
  {
    id: 27,
    starter: 'Custom Market ⭐',
    feature: '',
    pro: '',
    expert: '',
    intelligence: '',
  },
  {
    id: 28,
    feature: 'Custom Market ⭐',
    starter: 'no',
    pro: 'no',
    expert: 'yes',
    intelligence: 'yes',
  },
  {
    id: 29,
    starter: 'CSV data download',
    feature: '',
    pro: '',
    expert: '',
    intelligence: '',
  },
  {
    id: 30,
    feature: 'CSV data download',
    starter: 'no',
    pro: 'no',
    expert: 'no',
    intelligence: 'yes',
  },
  {
    id: 31,
    starter: 'Market Table View (Discovery)',
    feature: '',
    pro: '',
    expert: '',
    intelligence: '',
  },
  {
    id: 32,
    feature: 'Market Table View (Discovery)',
    starter: 'no',
    pro: 'no',
    expert: 'no',
    intelligence: 'yes',
  },
  {
    id: 33,
    starter: 'Markets Details Table View',
    feature: '',
    pro: '',
    expert: '',
    intelligence: '',
  },
  {
    id: 34,
    feature: 'Markets Details Table View',
    starter: 'no',
    pro: 'no',
    expert: 'no',
    intelligence: 'yes',
  },
  {
    id: 35,
    starter: 'Property Manager View',
    feature: '',
    pro: '',
    expert: '',
    intelligence: '',
  },
  {
    id: 36,
    feature: 'Property Manager View',
    starter: 'no',
    pro: 'no',
    expert: 'no',
    intelligence: 'yes',
  },
  {
    id: 37,
    starter: 'Listing Table View',
    feature: '',
    pro: '',
    expert: '',
    intelligence: '',
  },
  {
    id: 38,
    feature: 'Listing Table View',
    starter: 'no',
    pro: 'no',
    expert: 'no',
    intelligence: 'yes',
  },
  {
    id: 39,
    starter: 'Money Back Gurantee',
    feature: '',
    pro: '',
    expert: '',
    intelligence: '',
  },
  {
    id: 40,
    feature: 'Money Back Gurantee',
    starter: 'yes',
    pro: 'yes',
    expert: 'yes',
    intelligence: 'no',
  },
];

const SPAIN_DUMMY_MARKET = {
  overview: {
    district: 'cartagena',
    city: 'murcia',
    country: 'spain',
  },
  estimator: {
    address: 'Plaza de España, Plaza de España, Madrid, Spain',
    coordinates: { lat: 40.4167754, lng: -3.7037902 },
  },
};

const DUBAI_DUMMY_MARKET = {
  overview: {
    district: 'dubai production city',
    city: '0',
    country: 'united-arab-emirates',
  },
  estimator: {
    address: 'Dubai Internet City - Dubai - United Arab Emirates',
    coordinates: { lat: 25.0976119, lng: 55.163109 },
  },
};

const NOTH_ASIA_DUMMY_MARKET = {
  overview: {
    district: 'kuta beach, bali',
    city: '0',
    country: 'indonesia',
  },
  estimator: {
    address: 'Kuta Beach Skate Park, Kuta, Badung Regency, Bali, Indonesia',
    coordinates: { lat: -8.7133327, lng: 115.1675843 },
  },
};

const MEXICO_DUMMY_MARKET = {
  overview: {
    district: 'colonia condesa, mexico city',
    city: '0',
    country: 'mexico',
  },
  estimator: {
    address: 'Joaquina Beach, State of Santa Catarina, Brazil',
    coordinates: { lat: -27.6293577, lng: -48.4490173 },
  },
};

const US_CANADA_DUMMY_MARKET = {
  overview: {
    district: 'Boca Raton',
    city: 'FL',
    country: 'United-States',
  },
  estimator: {
    address: 'Ocean Drive, Miami Beach, FL, USA',
    coordinates: { lat: 25.7685168, lng: -80.1332062 },
  },
};

const AU_NZ_DUMMY_MARKET = {
  overview: {
    district: 'geelong',
    city: 'victoria',
    country: 'australia',
  },
  estimator: {
    address: 'Surfers Paradise Beach, Queensland, Australia',
    coordinates: { lat: -27.9992435, lng: 153.4314575 },
  },
};

export const DUMMY_MARKET_AS_PER_SIGNUP_COUNTRY_CODE = {
  GB: {
    overview: {
      district: 'the city of brighton and hove',
      city: '0',
      country: 'united-kingdom',
    },
    estimator: {
      address: 'Liverpool City Centre, Liverpool, UK',
      coordinates: { lat: 53.4047542, lng: -2.9811581 },
    },
  },
  FR: {
    overview: {
      district: 'antibes france',
      city: '0',
      country: 'france',
    },
    estimator: {
      address: 'Eiffel Tower, Avenue Gustave Eiffel, Paris, France',
      coordinates: { lat: 48.85837009999999, lng: 2.2944813 },
    },
  },
  IT: {
    overview: {
      district: 'syracuse italy',
      city: '0',
      country: 'italy',
    },
    estimator: {
      address: '39, PEPARINI ACADEMY, Via Assisi, Rome, Metropolitan City of Rome Capital, Italy',
      coordinates: { lat: 41.8792184, lng: 12.5251955 },
    },
  },
  AU: AU_NZ_DUMMY_MARKET,
  NZ: AU_NZ_DUMMY_MARKET,
  US: US_CANADA_DUMMY_MARKET,
  CA: US_CANADA_DUMMY_MARKET,
  ES: SPAIN_DUMMY_MARKET,
  AL: SPAIN_DUMMY_MARKET,
  AD: SPAIN_DUMMY_MARKET,
  AT: SPAIN_DUMMY_MARKET,
  BY: SPAIN_DUMMY_MARKET,
  BE: SPAIN_DUMMY_MARKET,
  BA: SPAIN_DUMMY_MARKET,
  BG: SPAIN_DUMMY_MARKET,
  HR: SPAIN_DUMMY_MARKET,
  CY: SPAIN_DUMMY_MARKET,
  CZ: SPAIN_DUMMY_MARKET,
  DK: SPAIN_DUMMY_MARKET,
  EE: SPAIN_DUMMY_MARKET,
  FI: SPAIN_DUMMY_MARKET,
  DE: SPAIN_DUMMY_MARKET,
  GR: SPAIN_DUMMY_MARKET,
  HU: SPAIN_DUMMY_MARKET,
  IS: SPAIN_DUMMY_MARKET,
  IE: SPAIN_DUMMY_MARKET,
  LI: SPAIN_DUMMY_MARKET,
  LV: SPAIN_DUMMY_MARKET,
  LT: SPAIN_DUMMY_MARKET,
  LU: SPAIN_DUMMY_MARKET,
  MK: SPAIN_DUMMY_MARKET,
  MT: SPAIN_DUMMY_MARKET,
  MD: SPAIN_DUMMY_MARKET,
  MC: SPAIN_DUMMY_MARKET,
  ME: SPAIN_DUMMY_MARKET,
  NL: SPAIN_DUMMY_MARKET,
  NO: SPAIN_DUMMY_MARKET,
  PL: SPAIN_DUMMY_MARKET,
  PT: SPAIN_DUMMY_MARKET,
  RO: SPAIN_DUMMY_MARKET,
  RU: SPAIN_DUMMY_MARKET,
  SM: SPAIN_DUMMY_MARKET,
  RS: SPAIN_DUMMY_MARKET,
  SK: SPAIN_DUMMY_MARKET,
  SI: SPAIN_DUMMY_MARKET,
  SE: SPAIN_DUMMY_MARKET,
  CH: SPAIN_DUMMY_MARKET,
  UA: SPAIN_DUMMY_MARKET,
  VA: SPAIN_DUMMY_MARKET,
  DZ: SPAIN_DUMMY_MARKET,
  AO: SPAIN_DUMMY_MARKET,
  BJ: SPAIN_DUMMY_MARKET,
  BW: SPAIN_DUMMY_MARKET,
  BF: SPAIN_DUMMY_MARKET,
  BI: SPAIN_DUMMY_MARKET,
  CV: SPAIN_DUMMY_MARKET,
  CM: SPAIN_DUMMY_MARKET,
  CF: SPAIN_DUMMY_MARKET,
  TD: SPAIN_DUMMY_MARKET,
  KM: SPAIN_DUMMY_MARKET,
  CD: SPAIN_DUMMY_MARKET,
  DJ: SPAIN_DUMMY_MARKET,
  EG: SPAIN_DUMMY_MARKET,
  GQ: SPAIN_DUMMY_MARKET,
  ER: SPAIN_DUMMY_MARKET,
  SZ: SPAIN_DUMMY_MARKET,
  ET: SPAIN_DUMMY_MARKET,
  GA: SPAIN_DUMMY_MARKET,
  GM: SPAIN_DUMMY_MARKET,
  GH: SPAIN_DUMMY_MARKET,
  GN: SPAIN_DUMMY_MARKET,
  GW: SPAIN_DUMMY_MARKET,
  CI: SPAIN_DUMMY_MARKET,
  KE: SPAIN_DUMMY_MARKET,
  LS: SPAIN_DUMMY_MARKET,
  LR: SPAIN_DUMMY_MARKET,
  LY: SPAIN_DUMMY_MARKET,
  MG: SPAIN_DUMMY_MARKET,
  MW: SPAIN_DUMMY_MARKET,
  ML: SPAIN_DUMMY_MARKET,
  MR: SPAIN_DUMMY_MARKET,
  MU: SPAIN_DUMMY_MARKET,
  MA: SPAIN_DUMMY_MARKET,
  MZ: SPAIN_DUMMY_MARKET,
  NA: SPAIN_DUMMY_MARKET,
  NE: SPAIN_DUMMY_MARKET,
  NG: SPAIN_DUMMY_MARKET,
  CG: SPAIN_DUMMY_MARKET,
  RW: SPAIN_DUMMY_MARKET,
  ST: SPAIN_DUMMY_MARKET,
  SN: SPAIN_DUMMY_MARKET,
  SC: SPAIN_DUMMY_MARKET,
  SL: SPAIN_DUMMY_MARKET,
  SO: SPAIN_DUMMY_MARKET,
  ZA: SPAIN_DUMMY_MARKET,
  SS: SPAIN_DUMMY_MARKET,
  SD: SPAIN_DUMMY_MARKET,
  TZ: SPAIN_DUMMY_MARKET,
  TG: SPAIN_DUMMY_MARKET,
  TN: SPAIN_DUMMY_MARKET,
  UG: SPAIN_DUMMY_MARKET,
  ZM: SPAIN_DUMMY_MARKET,
  ZW: SPAIN_DUMMY_MARKET,
  BH: DUBAI_DUMMY_MARKET,
  IQ: DUBAI_DUMMY_MARKET,
  IR: DUBAI_DUMMY_MARKET,
  IL: DUBAI_DUMMY_MARKET,
  JO: DUBAI_DUMMY_MARKET,
  KW: DUBAI_DUMMY_MARKET,
  LB: DUBAI_DUMMY_MARKET,
  OM: DUBAI_DUMMY_MARKET,
  PS: DUBAI_DUMMY_MARKET,
  QA: DUBAI_DUMMY_MARKET,
  SA: DUBAI_DUMMY_MARKET,
  SY: DUBAI_DUMMY_MARKET,
  TR: DUBAI_DUMMY_MARKET,
  AE: DUBAI_DUMMY_MARKET,
  YE: DUBAI_DUMMY_MARKET,
  AF: DUBAI_DUMMY_MARKET,
  BD: DUBAI_DUMMY_MARKET,
  BT: DUBAI_DUMMY_MARKET,
  IN: DUBAI_DUMMY_MARKET,
  MV: DUBAI_DUMMY_MARKET,
  NP: DUBAI_DUMMY_MARKET,
  PK: DUBAI_DUMMY_MARKET,
  LK: DUBAI_DUMMY_MARKET,
  CN: NOTH_ASIA_DUMMY_MARKET,
  JP: NOTH_ASIA_DUMMY_MARKET,
  KR: NOTH_ASIA_DUMMY_MARKET,
  KP: NOTH_ASIA_DUMMY_MARKET,
  MN: NOTH_ASIA_DUMMY_MARKET,
  TW: NOTH_ASIA_DUMMY_MARKET,
  BN: NOTH_ASIA_DUMMY_MARKET,
  KH: NOTH_ASIA_DUMMY_MARKET,
  ID: NOTH_ASIA_DUMMY_MARKET,
  LA: NOTH_ASIA_DUMMY_MARKET,
  MY: NOTH_ASIA_DUMMY_MARKET,
  MM: NOTH_ASIA_DUMMY_MARKET,
  PH: NOTH_ASIA_DUMMY_MARKET,
  SG: NOTH_ASIA_DUMMY_MARKET,
  TH: NOTH_ASIA_DUMMY_MARKET,
  VN: NOTH_ASIA_DUMMY_MARKET,
  KZ: NOTH_ASIA_DUMMY_MARKET,
  KG: NOTH_ASIA_DUMMY_MARKET,
  TJ: NOTH_ASIA_DUMMY_MARKET,
  TM: NOTH_ASIA_DUMMY_MARKET,
  UZ: NOTH_ASIA_DUMMY_MARKET,
  AM: NOTH_ASIA_DUMMY_MARKET,
  AZ: NOTH_ASIA_DUMMY_MARKET,
  GE: NOTH_ASIA_DUMMY_MARKET,
  AR: MEXICO_DUMMY_MARKET,
  BO: MEXICO_DUMMY_MARKET,
  BR: MEXICO_DUMMY_MARKET,
  CL: MEXICO_DUMMY_MARKET,
  CO: MEXICO_DUMMY_MARKET,
  CR: MEXICO_DUMMY_MARKET,
  CU: MEXICO_DUMMY_MARKET,
  DO: MEXICO_DUMMY_MARKET,
  EC: MEXICO_DUMMY_MARKET,
  SV: MEXICO_DUMMY_MARKET,
  GT: MEXICO_DUMMY_MARKET,
  HT: MEXICO_DUMMY_MARKET,
  HN: MEXICO_DUMMY_MARKET,
  MX: MEXICO_DUMMY_MARKET,
  NI: MEXICO_DUMMY_MARKET,
  PA: MEXICO_DUMMY_MARKET,
  PY: MEXICO_DUMMY_MARKET,
  PE: MEXICO_DUMMY_MARKET,
  UY: MEXICO_DUMMY_MARKET,
  VE: MEXICO_DUMMY_MARKET,
};
